/* eslint-disable */
// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,add_pb_suffix,ts_nocheck,eslint_disable
// @generated from protobuf file "company/models.proto" (package "rd.company", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { IntegrationVendor } from "../proto/integration_vendor/models_pb";
import { Money } from "../proto/money/models_pb";
import { CashRounding } from "../proto/money/models_pb";
import { Address } from "../proto/address/models_pb";
import { Address_Country } from "../proto/address/models_pb";
import { Decimal } from "../proto/decimal/models_pb";
import { Timestamp } from "../google/protobuf/timestamp_pb";
import { UUID } from "../proto/uuid/models_pb";
/**
 * Company represents a "company" a.k.a. "client" from our perspective.
 *
 * @generated from protobuf message rd.company.Company
 */
export interface Company {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: string name = 4
     */
    name: string;
    /**
     * @generated from protobuf field: string subdomain = 5
     */
    subdomain: string;
    /**
     * @generated from protobuf field: int32 pos_inactivity_timeout_minutes = 6
     */
    posInactivityTimeoutMinutes: number;
    /**
     * @generated from protobuf field: string reply_to_email = 7
     */
    replyToEmail: string;
    /**
     * @generated from protobuf field: int32 default_quote_expiry_days = 8
     */
    defaultQuoteExpiryDays: number;
    /**
     * @generated from protobuf field: string logo_image_url = 12
     */
    logoImageUrl: string;
    /**
     * @generated from protobuf field: string return_policy = 13
     */
    returnPolicy: string;
    /**
     * @generated from protobuf field: string website_url = 14
     */
    websiteUrl: string;
    /**
     * @generated from protobuf field: bool autolock_after_checkout = 15
     */
    autolockAfterCheckout: boolean;
    /**
     * @generated from protobuf field: bool is_benjamin_moore_supplier = 16
     */
    isBenjaminMooreSupplier: boolean;
    /**
     * @generated from protobuf field: bool should_auto_submit_ccp_rewards = 17
     */
    shouldAutoSubmitCcpRewards: boolean;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID default_location_id = 18
     */
    defaultLocationId?: UUID;
    /**
     * @generated from protobuf field: rd.company.Company.StatementDay statement_day = 19
     */
    statementDay: Company_StatementDay;
    /**
     * @generated from protobuf field: bool is_active = 20
     */
    isActive: boolean;
    /**
     * @generated from protobuf field: bool should_auto_submit_contractor_rewards = 21
     */
    shouldAutoSubmitContractorRewards: boolean;
    /**
     * @generated from protobuf field: string contractor_rewards_bonus_code = 22
     */
    contractorRewardsBonusCode: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp activated_at = 24
     */
    activatedAt?: Timestamp;
    /**
     * @generated from protobuf field: string statement_message = 27
     */
    statementMessage: string;
    /**
     * shows discount amount or original price crossed out on receipts
     *
     * @generated from protobuf field: bool is_discount_shown_to_customers = 29
     */
    isDiscountShownToCustomers: boolean;
    /**
     * @generated from protobuf field: bool is_color_formula_hidden = 31
     */
    isColorFormulaHidden: boolean;
    /**
     * @generated from protobuf field: bool is_price_shown_on_will_call = 32
     */
    isPriceShownOnWillCall: boolean;
    /**
     * @generated from protobuf field: bool is_loyalty_program_enabled = 33
     */
    isLoyaltyProgramEnabled: boolean;
    /**
     * @generated from protobuf field: string loyalty_program_policy = 34
     */
    loyaltyProgramPolicy: string;
    /**
     * @generated from protobuf field: bool should_auto_sign_out_after_sale = 35
     */
    shouldAutoSignOutAfterSale: boolean;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID default_entity_id = 37
     */
    defaultEntityId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID default_product_category_id = 39
     */
    defaultProductCategoryId?: UUID;
    /**
     * @generated from protobuf field: bool is_financing_terms_shown_on_invoice = 42
     */
    isFinancingTermsShownOnInvoice: boolean;
    /**
     * @generated from protobuf field: rd.company.Company.StatementEnvelopeType statement_envelope_type = 43
     */
    statementEnvelopeType: Company_StatementEnvelopeType;
    /**
     * @generated from protobuf field: bool is_cart_reader_sync_disabled = 44
     */
    isCartReaderSyncDisabled: boolean;
    /**
     * default deposit rate for special order product sales between 0-1
     *
     * @generated from protobuf field: rd.proto.decimal.Decimal default_deposit_rate = 46
     */
    defaultDepositRate?: Decimal;
    /**
     * @generated from protobuf field: rd.company.Company.CostBasisType cogs_margin_cost_basis_type = 47
     */
    cogsMarginCostBasisType: Company_CostBasisType;
    /**
     * @generated from protobuf field: bool should_set_ordered_product_quantity_to_zero = 50
     */
    shouldSetOrderedProductQuantityToZero: boolean;
    /**
     * @generated from protobuf field: rd.company.Company.CcpSubmissionCadence ccp_submission_cadence = 51
     */
    ccpSubmissionCadence: Company_CcpSubmissionCadence;
    /**
     * @generated from protobuf field: bool should_show_account_balance_on_receipt = 52
     */
    shouldShowAccountBalanceOnReceipt: boolean;
    /**
     * @generated from protobuf field: bool should_skip_linking_returns = 53
     */
    shouldSkipLinkingReturns: boolean;
    /**
     * @generated from protobuf field: bool is_setting_up_new_locations = 54
     */
    isSettingUpNewLocations: boolean;
    /**
     * @generated from protobuf field: bool is_nep_client = 55
     */
    isNepClient: boolean;
    /**
     * @generated from protobuf field: rd.company.Company.PrinterSettings printer_settings = 56
     */
    printerSettings?: Company_PrinterSettings;
    /**
     * @generated from protobuf field: bool should_auto_apply_return_credits = 57
     */
    shouldAutoApplyReturnCredits: boolean;
    /**
     * @generated from protobuf field: bool preserve_sale_product_price_edits = 58
     */
    preserveSaleProductPriceEdits: boolean;
    /**
     * @generated from protobuf field: bool should_require_internal_sale_notes_by_default = 59
     */
    shouldRequireInternalSaleNotesByDefault: boolean;
    /**
     * @generated from protobuf field: bool should_show_inventory_negative_warning = 60
     */
    shouldShowInventoryNegativeWarning: boolean;
    /**
     * @generated from protobuf field: bool is_discount_percentage_shown_on_receipt = 61
     */
    isDiscountPercentageShownOnReceipt: boolean;
    /**
     * @generated from protobuf field: bool allow_different_fulfillment_location = 62
     */
    allowDifferentFulfillmentLocation: boolean;
    /**
     * @generated from protobuf field: bool should_auto_apply_credits_on_statements = 63
     */
    shouldAutoApplyCreditsOnStatements: boolean;
    /**
     * @generated from protobuf field: string daily_summary_prompt = 64
     */
    dailySummaryPrompt: string;
    /**
     * @generated from protobuf field: bool should_require_void_reason = 65
     */
    shouldRequireVoidReason: boolean;
    /**
     * @generated from protobuf field: bool is_double_sided_statement_printing_enabled = 66
     */
    isDoubleSidedStatementPrintingEnabled: boolean;
    /**
     * @generated from protobuf field: bool should_require_customer_on_sale = 67
     */
    shouldRequireCustomerOnSale: boolean;
    /**
     * @generated from protobuf field: bool start_inventory_counts_at_on_hand = 68
     */
    startInventoryCountsAtOnHand: boolean;
    /**
     * @generated from protobuf field: bool is_gift_cards_enabled = 69
     */
    isGiftCardsEnabled: boolean;
    /**
     * @generated from protobuf field: rd.proto.address.Address.Country country = 70
     */
    country: Address_Country;
    /**
     * @generated from protobuf field: rd.company.Company.Search search = 71
     */
    search?: Company_Search;
    /**
     * When unset, transfer prints show cost/price for staff who have cost permissions (legacy
     * behavior). When false, costs and prices are hidden on transfer printouts for all staff.
     *
     * @generated from protobuf field: optional bool should_show_costs_on_transfer_prints = 72
     */
    shouldShowCostsOnTransferPrints?: boolean;
    /**
     * When true, orders are triggered when stock falls below the product minimum.
     * When false (default), orders are triggered when stock is at the minimum.
     *
     * @generated from protobuf field: bool should_trigger_order_when_stock_below_min = 73
     */
    shouldTriggerOrderWhenStockBelowMin: boolean;
    /**
     * @generated from protobuf field: bool is_pricing_by_region_enabled = 74
     */
    isPricingByRegionEnabled: boolean;
    /**
     * @generated from protobuf field: bool should_hide_return_confirmation = 76
     */
    shouldHideReturnConfirmation: boolean;
    /**
     * @generated from protobuf field: bool should_allow_returns_without_note = 77
     */
    shouldAllowReturnsWithoutNote: boolean;
    /**
     * @generated from protobuf field: rd.company.EcommerceSettings ecommerce_settings = 78
     */
    ecommerceSettings?: EcommerceSettings;
    /**
     * @generated from protobuf field: bool should_hide_all_product_images = 79
     */
    shouldHideAllProductImages: boolean;
    /**
     * @generated from protobuf field: bool should_hide_net_zero_activities_on_statements = 80
     */
    shouldHideNetZeroActivitiesOnStatements: boolean;
    /**
     * @generated from protobuf field: bool should_hide_category_browser = 81
     */
    shouldHideCategoryBrowser: boolean;
    /**
     * @generated from protobuf field: rd.company.Company.StatementEnvelopeMargins statement_envelope_margins = 82
     */
    statementEnvelopeMargins?: Company_StatementEnvelopeMargins;
    /**
     * @generated from protobuf field: bool should_allow_non_stock_price_cost_edits = 83
     */
    shouldAllowNonStockPriceCostEdits: boolean;
    /**
     * When false, sales still track a designated clerk but staff cannot see or
     * reassign it in the POS.
     *
     * @generated from protobuf field: bool is_designated_clerk_enabled = 84
     */
    isDesignatedClerkEnabled: boolean;
    /**
     * @generated from protobuf field: bool should_allow_non_stock_cost_edits = 85
     */
    shouldAllowNonStockCostEdits: boolean;
    /**
     * When true, the Edit Cost and Price modal on a purchase order derives the
     * standard and default cost from the one-time cost and leaves them read only.
     *
     * @generated from protobuf field: bool should_match_standard_and_default_to_one_time_cost = 86
     */
    shouldMatchStandardAndDefaultToOneTimeCost: boolean;
    /**
     * @generated from protobuf field: rd.company.Company.TaxRateMode tax_rate_mode = 87
     */
    taxRateMode: Company_TaxRateMode;
    /**
     * @generated from protobuf field: bool is_bm_data_sharing_enabled = 88
     */
    isBmDataSharingEnabled: boolean;
    /**
     * @generated from protobuf field: bool is_deposits_and_partial_fulfillment_enabled = 89
     */
    isDepositsAndPartialFulfillmentEnabled: boolean;
    /**
     * @generated from protobuf field: bool should_warn_when_selling_below_cost = 90
     */
    shouldWarnWhenSellingBelowCost: boolean;
}
/**
 * @generated from protobuf message rd.company.Company.PrinterSettings
 */
export interface Company_PrinterSettings {
    /**
     * @generated from protobuf field: int32 default_receipt_quantity = 1
     */
    defaultReceiptQuantity: number;
    /**
     * @generated from protobuf field: bool should_quick_print_thermal = 3
     */
    shouldQuickPrintThermal: boolean;
    /**
     * @generated from protobuf field: bool should_quick_print_full_page = 4
     */
    shouldQuickPrintFullPage: boolean;
    /**
     * @generated from protobuf field: bool quick_print_show_prices = 5
     */
    quickPrintShowPrices: boolean;
    /**
     * @generated from protobuf field: map<string, rd.company.Company.PrinterSettings.LocationSettings> settings_by_location_id = 6
     */
    settingsByLocationId: {
        [key: string]: Company_PrinterSettings_LocationSettings;
    };
    /**
     * @generated from protobuf field: bool should_auto_print_new_sales_and_receivables = 7
     */
    shouldAutoPrintNewSalesAndReceivables: boolean;
    /**
     * @generated from protobuf field: bool should_auto_print_completed_sales_and_receivables = 8
     */
    shouldAutoPrintCompletedSalesAndReceivables: boolean;
}
/**
 * @generated from protobuf message rd.company.Company.PrinterSettings.LocationSettings
 */
export interface Company_PrinterSettings_LocationSettings {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID quick_print_printer_id = 1
     */
    quickPrintPrinterId?: UUID;
}
/**
 * @generated from protobuf message rd.company.Company.Search
 */
export interface Company_Search {
    /**
     * @generated from protobuf field: double size_GB = 1
     */
    sizeGB: number;
    /**
     * @generated from protobuf field: bool is_size_overridden = 2
     */
    isSizeOverridden: boolean;
    /**
     * @generated from protobuf field: string domain = 3
     */
    domain: string;
    /**
     * @generated from protobuf field: int64 replicas = 4
     */
    replicas: bigint;
    /**
     * cron string in America/Los_Angeles time
     *
     * @generated from protobuf field: string replicas_start_cron = 5
     */
    replicasStartCron: string;
    /**
     * cron string in America/Los_Angeles time
     *
     * @generated from protobuf field: string replicas_end_cron = 6
     */
    replicasEndCron: string;
}
/**
 * StatementEnvelopeMargins positions statement address blocks, in inches.
 * When set, it drives rendering regardless of StatementEnvelopeType.
 * Enforced by Validate in rd/company.
 *
 * @generated from protobuf message rd.company.Company.StatementEnvelopeMargins
 */
export interface Company_StatementEnvelopeMargins {
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal from_address_top_margin = 1
     */
    fromAddressTopMargin?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal from_address_left_margin = 2
     */
    fromAddressLeftMargin?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal to_address_top_margin = 3
     */
    toAddressTopMargin?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal to_address_left_margin = 4
     */
    toAddressLeftMargin?: Decimal;
}
/**
 * @generated from protobuf enum rd.company.Company.StatementDay
 */
export enum Company_StatementDay {
    /**
     * @generated from protobuf enum value: STATEMENT_DAY_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: STATEMENT_DAY_ONE = 1;
     */
    ONE = 1,
    /**
     * @generated from protobuf enum value: STATEMENT_DAY_TWO = 2;
     */
    TWO = 2,
    /**
     * @generated from protobuf enum value: STATEMENT_DAY_THREE = 3;
     */
    THREE = 3,
    /**
     * @generated from protobuf enum value: STATEMENT_DAY_FOUR = 4;
     */
    FOUR = 4,
    /**
     * @generated from protobuf enum value: STATEMENT_DAY_FIVE = 5;
     */
    FIVE = 5,
    /**
     * @generated from protobuf enum value: STATEMENT_DAY_SIX = 6;
     */
    SIX = 6,
    /**
     * @generated from protobuf enum value: STATEMENT_DAY_SEVEN = 7;
     */
    SEVEN = 7,
    /**
     * @generated from protobuf enum value: STATEMENT_DAY_EIGHT = 8;
     */
    EIGHT = 8,
    /**
     * @generated from protobuf enum value: STATEMENT_DAY_NINE = 9;
     */
    NINE = 9,
    /**
     * @generated from protobuf enum value: STATEMENT_DAY_TEN = 10;
     */
    TEN = 10,
    /**
     * @generated from protobuf enum value: STATEMENT_DAY_ELEVEN = 11;
     */
    ELEVEN = 11,
    /**
     * @generated from protobuf enum value: STATEMENT_DAY_TWELVE = 12;
     */
    TWELVE = 12,
    /**
     * @generated from protobuf enum value: STATEMENT_DAY_THIRTEEN = 13;
     */
    THIRTEEN = 13,
    /**
     * @generated from protobuf enum value: STATEMENT_DAY_FOURTEEN = 14;
     */
    FOURTEEN = 14,
    /**
     * @generated from protobuf enum value: STATEMENT_DAY_FIFTEEN = 15;
     */
    FIFTEEN = 15,
    /**
     * @generated from protobuf enum value: STATEMENT_DAY_SIXTEEN = 16;
     */
    SIXTEEN = 16,
    /**
     * @generated from protobuf enum value: STATEMENT_DAY_SEVENTEEN = 17;
     */
    SEVENTEEN = 17,
    /**
     * @generated from protobuf enum value: STATEMENT_DAY_EIGHTEEN = 18;
     */
    EIGHTEEN = 18,
    /**
     * @generated from protobuf enum value: STATEMENT_DAY_NINETEEN = 19;
     */
    NINETEEN = 19,
    /**
     * @generated from protobuf enum value: STATEMENT_DAY_TWENTY = 20;
     */
    TWENTY = 20,
    /**
     * @generated from protobuf enum value: STATEMENT_DAY_TWENTYONE = 21;
     */
    TWENTYONE = 21,
    /**
     * @generated from protobuf enum value: STATEMENT_DAY_TWENTYTWO = 22;
     */
    TWENTYTWO = 22,
    /**
     * @generated from protobuf enum value: STATEMENT_DAY_TWENTYTHREE = 23;
     */
    TWENTYTHREE = 23,
    /**
     * @generated from protobuf enum value: STATEMENT_DAY_TWENTYFOUR = 24;
     */
    TWENTYFOUR = 24,
    /**
     * @generated from protobuf enum value: STATEMENT_DAY_TWENTYFIVE = 25;
     */
    TWENTYFIVE = 25,
    /**
     * @generated from protobuf enum value: STATEMENT_DAY_TWENTYSIX = 26;
     */
    TWENTYSIX = 26,
    /**
     * @generated from protobuf enum value: STATEMENT_DAY_TWENTYSEVEN = 27;
     */
    TWENTYSEVEN = 27,
    /**
     * @generated from protobuf enum value: STATEMENT_DAY_TWENTYEIGHT = 28;
     */
    TWENTYEIGHT = 28,
    /**
     * @generated from protobuf enum value: STATEMENT_DAY_END_OF_MONTH = 29;
     */
    END_OF_MONTH = 29
}
/**
 * @generated from protobuf enum rd.company.Company.StatementEnvelopeType
 */
export enum Company_StatementEnvelopeType {
    /**
     * @generated from protobuf enum value: STATEMENT_ENVELOPE_TYPE_UNDEFINED = 0;
     */
    STATEMENT_ENVELOPE_TYPE_UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: STATEMENT_ENVELOPE_TYPE_6X9_3H_BOOKLET_WINDOW = 1;
     */
    STATEMENT_ENVELOPE_TYPE_6X9_3H_BOOKLET_WINDOW = 1,
    /**
     * @generated from protobuf enum value: STATEMENT_ENVELOPE_TYPE_10_DOUBLE_WINDOW = 2;
     */
    STATEMENT_ENVELOPE_TYPE_10_DOUBLE_WINDOW = 2,
    /**
     * @generated from protobuf enum value: STATEMENT_ENVELOPE_TYPE_CUSTOM = 3;
     */
    STATEMENT_ENVELOPE_TYPE_CUSTOM = 3
}
/**
 * type that dictates which cost is used for margin/cogs calculations
 *
 * @generated from protobuf enum rd.company.Company.CostBasisType
 */
export enum Company_CostBasisType {
    /**
     * @generated from protobuf enum value: COST_BASIS_TYPE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: COST_BASIS_TYPE_STANDARD_COST = 1;
     */
    STANDARD_COST = 1,
    /**
     * @generated from protobuf enum value: COST_BASIS_TYPE_AVERAGE_COST = 2;
     */
    AVERAGE_COST = 2
}
/**
 * @generated from protobuf enum rd.company.Company.CcpSubmissionCadence
 */
export enum Company_CcpSubmissionCadence {
    /**
     * @generated from protobuf enum value: CCP_SUBMISSION_CADENCE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: CCP_SUBMISSION_CADENCE_DAILY = 1;
     */
    DAILY = 1,
    /**
     * @generated from protobuf enum value: CCP_SUBMISSION_CADENCE_WEEKLY = 2;
     */
    WEEKLY = 2,
    /**
     * @generated from protobuf enum value: CCP_SUBMISSION_CADENCE_MONTHLY = 3;
     */
    MONTHLY = 3
}
/**
 * Controls which tax rate a delivery sale uses.
 *
 * @generated from protobuf enum rd.company.Company.TaxRateMode
 */
export enum Company_TaxRateMode {
    /**
     * @generated from protobuf enum value: TAX_RATE_MODE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: TAX_RATE_MODE_STORE_ADDRESS = 1;
     */
    STORE_ADDRESS = 1,
    /**
     * @generated from protobuf enum value: TAX_RATE_MODE_PROMPT = 2;
     */
    PROMPT = 2,
    /**
     * @generated from protobuf enum value: TAX_RATE_MODE_DELIVERY_ADDRESS = 3;
     */
    DELIVERY_ADDRESS = 3
}
/**
 * @generated from protobuf message rd.company.EcommerceSettings
 */
export interface EcommerceSettings {
    /**
     * @generated from protobuf field: bool is_ecomm_enabled = 1
     */
    isEcommEnabled: boolean;
    /**
     * @generated from protobuf field: map<string, rd.company.EcommerceSettings.LocationSettings> settings_by_location_id = 3
     */
    settingsByLocationId: {
        [key: string]: EcommerceSettings_LocationSettings;
    };
}
/**
 * @generated from protobuf message rd.company.EcommerceSettings.LocationSettings
 */
export interface EcommerceSettings_LocationSettings {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID receipt_printer_id = 1
     */
    receiptPrinterId?: UUID;
    /**
     * @generated from protobuf field: bool ignore_inventory_levels = 2
     */
    ignoreInventoryLevels: boolean;
}
/**
 * Location represents a Company store location.
 *
 * @generated from protobuf message rd.company.Location
 */
export interface Location {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 4
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: string prefix = 5
     */
    prefix: string;
    /**
     * @generated from protobuf field: string name = 6
     */
    name: string;
    /**
     * @generated from protobuf field: string phone = 7
     */
    phone: string;
    /**
     * @generated from protobuf field: rd.proto.address.Address address = 8
     */
    address?: Address;
    /**
     * @generated from protobuf field: bool is_active = 9
     */
    isActive: boolean;
    /**
     * @generated from protobuf field: string time_zone = 10
     */
    timeZone: string;
    /**
     * @generated from protobuf field: string stripe_location_id = 11
     */
    stripeLocationId: string;
    /**
     * @generated from protobuf field: string bm_outlet_number = 13
     */
    bmOutletNumber: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID entity_id = 15
     */
    entityId?: UUID;
    /**
     * @generated from protobuf field: string reply_to_email = 16
     */
    replyToEmail: string;
    /**
     * @generated from protobuf field: string logo_image_url = 17
     */
    logoImageUrl: string;
    /**
     * @generated from protobuf field: string google_review_url = 18
     */
    googleReviewUrl: string;
    /**
     * @generated from protobuf field: string quickbooks_class = 19
     */
    quickbooksClass: string;
    /**
     * @generated from protobuf field: string display_name = 20
     */
    displayName: string;
    /**
     * @generated from protobuf field: string statement_message = 21
     */
    statementMessage: string;
    /**
     * @generated from protobuf field: bool cc_on_emails = 22
     */
    ccOnEmails: boolean;
    /**
     * @generated from protobuf field: string twilio_phone = 23
     */
    twilioPhone: string;
    /**
     * @generated from protobuf field: rd.company.Location.OutboundEmail outbound_email = 24
     */
    outboundEmail?: Location_OutboundEmail;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID pricing_region_id = 25
     */
    pricingRegionId?: UUID; // potentially nil, eventually required
    /**
     * @generated from protobuf field: rd.proto.money.CashRounding cash_rounding = 26
     */
    cashRounding?: CashRounding;
    /**
     * @generated from protobuf field: bool show_inventory = 27
     */
    showInventory: boolean;
}
/**
 * OutboundEmail stores the sender email configuration for this location
 * consists of a username on an authenticated domain from the company
 *
 * @generated from protobuf message rd.company.Location.OutboundEmail
 */
export interface Location_OutboundEmail {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID custom_email_config_id = 1
     */
    customEmailConfigId?: UUID;
    /**
     * @generated from protobuf field: string username = 2
     */
    username: string;
    /**
     * @generated from protobuf field: string domain = 3
     */
    domain: string;
}
/**
 * Staff represents Company staff members.
 *
 * @generated from protobuf message rd.company.Staff
 */
export interface Staff {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 4
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: string first_name = 5
     */
    firstName: string;
    /**
     * @generated from protobuf field: string last_name = 6
     */
    lastName: string;
    /**
     * @generated from protobuf field: string phone = 7
     */
    phone: string;
    /**
     * @generated from protobuf field: bool is_active = 8
     */
    isActive: boolean;
    /**
     * @generated from protobuf field: string email = 9
     */
    email: string;
    /**
     * @generated from protobuf field: rd.proto.address.Address address = 10
     */
    address?: Address;
    /**
     * @generated from protobuf field: string stytch_user_id = 11
     */
    stytchUserId: string;
    /**
     * @generated from protobuf field: string code = 12
     */
    code: string;
    /**
     * @generated from protobuf field: repeated string role_ids = 13
     */
    roleIds: string[];
    /**
     * @generated from protobuf field: string stripe_issuing_cardholder_id = 14
     */
    stripeIssuingCardholderId: string;
    /**
     * @generated from protobuf field: repeated string webauthn_pubkey_ids = 15
     */
    webauthnPubkeyIds: string[];
    /**
     * @generated from protobuf field: bool sms_consent = 16
     */
    smsConsent: boolean;
    /**
     * @generated from protobuf field: bool email_consent = 17
     */
    emailConsent: boolean;
    /**
     * @generated from protobuf field: bool is_attribution_enabled = 18
     */
    isAttributionEnabled: boolean;
    /**
     * @generated from protobuf field: bytes attribution_pin = 19
     */
    attributionPin: Uint8Array; // encrypted
}
/**
 * PricingTiers represents a company's pricing tiers (comprised of a name).
 * that determines the price customers will be charged for a product.
 *
 * @generated from protobuf message rd.company.PricingTiers
 */
export interface PricingTiers {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID; // company id
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: string default_id_string = 4
     */
    defaultIdString: string;
    /**
     * @generated from protobuf field: map<string, rd.company.PricingTiers.Tier> tiers_by_id = 5
     */
    tiersById: {
        [key: string]: PricingTiers_Tier;
    };
}
/**
 * @generated from protobuf message rd.company.PricingTiers.Tier
 */
export interface PricingTiers_Tier {
    /**
     * @generated from protobuf field: string id_string = 1
     */
    idString: string;
    /**
     * @generated from protobuf field: string name = 2
     */
    name: string;
    /**
     * @generated from protobuf field: int32 rank = 3
     */
    rank: number; // 1-indexed
    /**
     * @generated from protobuf field: bool is_rule_based = 4
     */
    isRuleBased: boolean;
}
/**
 * PricingTiersLog represents a change of a PricingTiers.
 *
 * @generated from protobuf message rd.company.PricingTiersLog
 */
export interface PricingTiersLog {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.company.PricingTiers pricing_tiers = 3
     */
    pricingTiers?: PricingTiers;
}
/**
 * FinancingTerms represents a company's financing terms (comprised of a
 * reference date, number of due days, and discount) that determines when
 * payment for a Sale will be due.
 *
 * @generated from protobuf message rd.company.FinancingTerms
 */
export interface FinancingTerms {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID; // company id
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: string default_id_string = 4
     */
    defaultIdString: string;
    /**
     * @generated from protobuf field: map<string, rd.company.FinancingTerms.Term> terms_by_id = 5
     */
    termsById: {
        [key: string]: FinancingTerms_Term;
    };
}
/**
 * @generated from protobuf message rd.company.FinancingTerms.Term
 */
export interface FinancingTerms_Term {
    /**
     * @generated from protobuf field: string id_string = 1
     */
    idString: string;
    /**
     * @generated from protobuf field: rd.company.FinancingTerms.Term.ReferenceDate reference_date = 2
     */
    referenceDate: FinancingTerms_Term_ReferenceDate;
    /**
     * @generated from protobuf field: int32 due_days = 3
     */
    dueDays: number;
    /**
     * @generated from protobuf field: int32 discount_days = 4
     */
    discountDays: number; // maps to discount reference days
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal discount_rate = 5
     */
    discountRate?: Decimal; // maps to discount percentage
    /**
     * @generated from protobuf field: int32 position = 6
     */
    position: number; // 1-indexed
    /**
     * @generated from protobuf field: bool is_early_payment_discount_enabled = 7
     */
    isEarlyPaymentDiscountEnabled: boolean;
    /**
     * @generated from protobuf field: string name = 8
     */
    name: string;
}
/**
 * @generated from protobuf enum rd.company.FinancingTerms.Term.ReferenceDate
 */
export enum FinancingTerms_Term_ReferenceDate {
    /**
     * @generated from protobuf enum value: REFERENCE_DATE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: REFERENCE_DATE_INVOICE = 1;
     */
    INVOICE = 1,
    /**
     * @generated from protobuf enum value: REFERENCE_DATE_STATEMENT = 2;
     */
    STATEMENT = 2,
    /**
     * @generated from protobuf enum value: REFERENCE_DATE_END_OF_MONTH = 3;
     */
    END_OF_MONTH = 3,
    /**
     * @generated from protobuf enum value: REFERENCE_DATE_STATEMENT_END_OF_MONTH = 4;
     */
    STATEMENT_END_OF_MONTH = 4
}
/**
 * FinancingTermsLog represents a change of a FinancingTerms.
 *
 * @generated from protobuf message rd.company.FinancingTermsLog
 */
export interface FinancingTermsLog {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.company.FinancingTerms financing_terms = 3
     */
    financingTerms?: FinancingTerms;
}
/**
 * AdditionalFees represents additional fees that a company
 * may optionally assign to a product.
 *
 * @generated from protobuf message rd.company.AdditionalFees
 */
export interface AdditionalFees {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID; // Company ID
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: map<string, rd.company.AdditionalFees.Fee> fees_by_id = 4
     */
    feesById: {
        [key: string]: AdditionalFees_Fee;
    };
}
/**
 * @generated from protobuf message rd.company.AdditionalFees.LocationFeeOverride
 */
export interface AdditionalFees_LocationFeeOverride {
    /**
     * @generated from protobuf field: rd.proto.money.Money fee = 1
     */
    fee?: Money;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal fee_rate = 2
     */
    feeRate?: Decimal;
}
/**
 * @generated from protobuf message rd.company.AdditionalFees.Fee
 */
export interface AdditionalFees_Fee {
    /**
     * @generated from protobuf field: string id_string = 1
     */
    idString: string;
    /**
     * @generated from protobuf field: string name = 2
     */
    name: string;
    /**
     * @generated from protobuf field: rd.proto.money.Money fee = 3
     */
    fee?: Money;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal fee_rate = 4
     */
    feeRate?: Decimal;
    /**
     * @generated from protobuf field: bool is_taxable = 5
     */
    isTaxable: boolean;
    /**
     * @generated from protobuf field: int32 position = 6
     */
    position: number; // 1-indexed
    /**
     * @generated from protobuf field: bool apply_to_sales = 7
     */
    applyToSales: boolean;
    /**
     * @generated from protobuf field: bool apply_to_orders = 8
     */
    applyToOrders: boolean;
    /**
     * @generated from protobuf field: bool apply_to_transfers = 9
     */
    applyToTransfers: boolean;
    /**
     * key is location id, value is whether to apply the fee to the location
     *
     * @generated from protobuf field: map<string, bool> apply_to_location_ids = 10
     */
    applyToLocationIds: {
        [key: string]: boolean;
    };
    /**
     * key is location id, value is the fee override for that location
     *
     * @generated from protobuf field: map<string, rd.company.AdditionalFees.LocationFeeOverride> fee_override_by_location_id = 11
     */
    feeOverrideByLocationId: {
        [key: string]: AdditionalFees_LocationFeeOverride;
    };
    /**
     * @generated from protobuf field: rd.company.AdditionalFees.Fee.Type type = 12
     */
    type: AdditionalFees_Fee_Type;
    /**
     * @generated from protobuf field: bool is_active = 13
     */
    isActive: boolean;
    /**
     * @generated from protobuf field: rd.company.AdditionalFees.Fee.OverrideType override_type = 14
     */
    overrideType: AdditionalFees_Fee_OverrideType;
    /**
     * @generated from protobuf field: map<string, bool> apply_to_states = 15
     */
    applyToStates: {
        [key: string]: boolean;
    }; // key is state abbreviation
    /**
     * @generated from protobuf field: map<string, rd.company.AdditionalFees.LocationFeeOverride> fee_override_by_state = 16
     */
    feeOverrideByState: {
        [key: string]: AdditionalFees_LocationFeeOverride;
    }; // key is state abbreviation
}
/**
 * @generated from protobuf enum rd.company.AdditionalFees.Fee.Type
 */
export enum AdditionalFees_Fee_Type {
    /**
     * @generated from protobuf enum value: TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: TYPE_ECO_FEE = 1;
     */
    ECO_FEE = 1,
    /**
     * @generated from protobuf enum value: TYPE_TAX = 2;
     */
    TAX = 2
}
/**
 * @generated from protobuf enum rd.company.AdditionalFees.Fee.OverrideType
 */
export enum AdditionalFees_Fee_OverrideType {
    /**
     * both maps empty
     *
     * @generated from protobuf enum value: OVERRIDE_TYPE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * default for backfill, location maps only
     *
     * @generated from protobuf enum value: OVERRIDE_TYPE_LOCATION = 1;
     */
    LOCATION = 1,
    /**
     * state maps only
     *
     * @generated from protobuf enum value: OVERRIDE_TYPE_STATE = 2;
     */
    STATE = 2
}
/**
 * AdditionalFeesLog represents a change of an AdditionalFees.
 *
 * @generated from protobuf message rd.company.AdditionalFeesLog
 */
export interface AdditionalFeesLog {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.company.AdditionalFees additional_fees = 3
     */
    additionalFees?: AdditionalFees;
}
/**
 * ProductCategory represents a category of products that can be used to group
 * products together.
 *
 * @generated from protobuf message rd.company.ProductCategory
 */
export interface ProductCategory {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 4
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: string name = 5
     */
    name: string;
    /**
     * @generated from protobuf field: rd.company.ProductCategory.Type type = 6
     */
    type: ProductCategory_Type;
    /**
     * @generated from protobuf field: bool is_active = 7
     */
    isActive: boolean;
    /**
     * @generated from protobuf field: string icon_name = 8
     */
    iconName: string;
}
/**
 * @generated from protobuf enum rd.company.ProductCategory.Type
 */
export enum ProductCategory_Type {
    /**
     * @generated from protobuf enum value: TYPE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: TYPE_DEPARTMENT = 1;
     */
    DEPARTMENT = 1,
    /**
     * @generated from protobuf enum value: TYPE_CLASS = 2;
     */
    CLASS = 2,
    /**
     * @generated from protobuf enum value: TYPE_FINELINE = 3;
     */
    FINELINE = 3
}
/**
 * Roles represent groups of staff members with api endpoint permissions.
 *
 * @generated from protobuf message rd.company.Roles
 */
export interface Roles {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID; // Company ID
    /**
     * @generated from protobuf field: map<string, rd.company.Roles.Role> roles_by_id = 2
     */
    rolesById: {
        [key: string]: Roles_Role;
    };
}
/**
 * @generated from protobuf message rd.company.Roles.Role
 */
export interface Roles_Role {
    /**
     * @generated from protobuf field: string id_string = 1
     */
    idString: string;
    /**
     * @generated from protobuf field: string name = 2
     */
    name: string;
    /**
     * key is `<twirp service>/<twirp method>`
     *
     * @generated from protobuf field: map<string, bool> permissions = 3
     */
    permissions: {
        [key: string]: boolean;
    };
    /**
     * @generated from protobuf field: repeated string linked_roles = 4
     */
    linkedRoles: string[];
    /**
     * @generated from protobuf field: string category = 5
     */
    category: string; // groups permissions groups together visually in frontend
    /**
     * @generated from protobuf field: string description = 6
     */
    description: string; // describes permissions group in frontend
    /**
     * @generated from protobuf field: int32 position = 7
     */
    position: number; // orders permissions groups in frontend
}
/**
 * DooerStaff is a pseudo-staff representing a Dooer.
 *
 * @generated from protobuf message rd.company.DooerStaff
 */
export interface DooerStaff {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: string phone = 5
     */
    phone: string;
    /**
     * @generated from protobuf field: string email = 6
     */
    email: string;
    /**
     * @generated from protobuf field: string stytch_user_id = 7
     */
    stytchUserId: string;
    /**
     * @generated from protobuf field: string code = 8
     */
    code: string;
}
/**
 * CashRegister represents a cash register at a company's location.
 *
 * @generated from protobuf message rd.company.CashRegister
 */
export interface CashRegister {
    /**
     * for the default cash register, the id is the same as the location id
     *
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID; // cash_register_id
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.money.Money balance = 4
     */
    balance?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money float = 5
     */
    float?: Money;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 6
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 7
     */
    locationId?: UUID; // previously also the unique id for the cash register
    /**
     * @generated from protobuf field: string name = 8
     */
    name: string; // name of the cash register
    /**
     * @generated from protobuf field: bool is_active = 9
     */
    isActive: boolean; // whether the cash register is active (true) or deleted (false)
}
/**
 * CxaUser represents a user of the customer app. A CxaUser is uniquely
 * identified by their phone number and maps to one or more customer.Customers
 * by whether the Customer has a Contact with that phone number. CxaUsers are
 * automatically created the first time a user logs in with a new phone number.
 *
 * @generated from protobuf message rd.company.CxaUser
 */
export interface CxaUser {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: string phone = 3
     */
    phone: string;
    /**
     * @generated from protobuf field: string stytch_user_id = 4
     */
    stytchUserId: string;
}
/**
 * TaxRate represents a sales tax rate for a company. This can either be
 * location specific or a custom rate.
 *
 * @generated from protobuf message rd.company.TaxRate
 */
export interface TaxRate {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID; // location_id for location rates
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 4
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: string name = 5
     */
    name: string;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal rate = 6
     */
    rate?: Decimal;
    /**
     * @generated from protobuf field: int32 position = 7
     */
    position: number; // only used for custom rates as they can be ordered
    /**
     * @generated from protobuf field: bool is_active = 8
     */
    isActive: boolean;
    /**
     * @generated from protobuf field: rd.company.TaxRate.Type type = 9
     */
    type: TaxRate_Type;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID location_ids = 10
     */
    locationIds: UUID[];
}
/**
 * @generated from protobuf enum rd.company.TaxRate.Type
 */
export enum TaxRate_Type {
    /**
     * @generated from protobuf enum value: TYPE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: TYPE_CUSTOM_RATE = 1;
     */
    CUSTOM_RATE = 1,
    /**
     * @generated from protobuf enum value: TYPE_LOCATION_RATE = 2;
     */
    LOCATION_RATE = 2
}
/**
 * TaxRateLog represents a change of a TaxRate.
 *
 * @generated from protobuf message rd.company.TaxRateLog
 */
export interface TaxRateLog {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.company.TaxRate tax_rate = 3
     */
    taxRate?: TaxRate;
}
/**
 * Entity represents a legal business entity
 *
 * @generated from protobuf message rd.company.Entity
 */
export interface Entity {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 2
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 3
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 4
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: string stripe_express_account_id = 5
     */
    stripeExpressAccountId: string; // deprecated but still in use
    /**
     * @generated from protobuf field: string stripe_custom_account_id = 6
     */
    stripeCustomAccountId: string;
    /**
     * @generated from protobuf field: string stripe_financial_account_id = 7
     */
    stripeFinancialAccountId: string;
    /**
     * @generated from protobuf field: string stripe_bank_payment_method_id = 8
     */
    stripeBankPaymentMethodId: string;
    /**
     * @generated from protobuf field: string name = 9
     */
    name: string;
    /**
     * @generated from protobuf field: rd.proto.address.Address.Country country = 10
     */
    country: Address_Country;
    /**
     * @generated from protobuf field: string stripe_customer_account_id = 11
     */
    stripeCustomerAccountId: string;
    /**
     * @generated from protobuf field: repeated rd.company.Entity.Billing billings = 12
     */
    billings: Entity_Billing[];
}
/**
 * @generated from protobuf message rd.company.Entity.Billing
 */
export interface Entity_Billing {
    /**
     * @generated from protobuf field: rd.company.Entity.Billing.Type type = 1
     */
    type: Entity_Billing_Type;
    /**
     * @generated from protobuf field: string stripe_subscription_id = 2
     */
    stripeSubscriptionId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp next_billing_date = 3
     */
    nextBillingDate?: Timestamp;
    /**
     * @generated from protobuf field: string stripe_subscription_schedule_id = 4
     */
    stripeSubscriptionScheduleId: string;
}
/**
 * @generated from protobuf enum rd.company.Entity.Billing.Type
 */
export enum Entity_Billing_Type {
    /**
     * @generated from protobuf enum value: TYPE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: TYPE_SAAS = 1;
     */
    SAAS = 1
}
/**
 * EntityLog represents the state of an Entity after a change
 *
 * @generated from protobuf message rd.company.EntityLog
 */
export interface EntityLog {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.company.Entity entity = 3
     */
    entity?: Entity;
}
/**
 * FinanceChargeSetting represents a company's Finance Charge that,
 * combined with finance terms, determines how much
 * a customer gets charged for use of credit.
 *
 * @generated from protobuf message rd.company.FinanceChargeSetting
 */
export interface FinanceChargeSetting {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 2
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 3
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 4
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal percentage_fee = 5
     */
    percentageFee?: Decimal; // between 0 and 1
    /**
     * @generated from protobuf field: rd.proto.money.Money min_assessment_balance = 6
     */
    minAssessmentBalance?: Money; // greater than or equal to 0
    /**
     * @generated from protobuf field: rd.proto.money.Money min_charge_fee = 7
     */
    minChargeFee?: Money; // greater than or equal to 0
    /**
     * @generated from protobuf field: int32 grace_period_days = 8
     */
    gracePeriodDays: number; // greater than or equal to 0
    /**
     * @generated from protobuf field: bool is_compounded = 9
     */
    isCompounded: boolean;
    /**
     * @generated from protobuf field: int32 position = 10
     */
    position: number; // 1-indexed
    /**
     * @generated from protobuf field: bool is_active = 11
     */
    isActive: boolean;
    /**
     * @generated from protobuf field: bool is_default = 12
     */
    isDefault: boolean;
    /**
     * @generated from protobuf field: string name = 13
     */
    name: string; // unique
}
/**
 * @generated from protobuf message rd.company.SaleForm
 */
export interface SaleForm {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 2
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 3
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 4
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: string name = 5
     */
    name: string;
    /**
     * @generated from protobuf field: repeated rd.company.SaleForm.CustomField custom_fields = 6
     */
    customFields: SaleForm_CustomField[];
}
/**
 * @generated from protobuf message rd.company.SaleForm.CustomField
 */
export interface SaleForm_CustomField {
    /**
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * @generated from protobuf field: rd.company.SaleForm.InputType input_type = 2
     */
    inputType: SaleForm_InputType;
    /**
     * @generated from protobuf field: string string_value = 3
     */
    stringValue: string;
}
/**
 * @generated from protobuf enum rd.company.SaleForm.InputType
 */
export enum SaleForm_InputType {
    /**
     * @generated from protobuf enum value: TYPE_UNDEFINED = 0;
     */
    TYPE_UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: TYPE_TEXTFIELD = 1;
     */
    TYPE_TEXTFIELD = 1,
    /**
     * @generated from protobuf enum value: TYPE_PARAGRAPH = 2;
     */
    TYPE_PARAGRAPH = 2
}
/**
 * UnitOfMeasure represents a unit of measure for a product.
 *
 * @generated from protobuf message rd.company.UnitOfMeasure
 */
export interface UnitOfMeasure {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID; // unit_of_measure_id
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 2
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 3
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 4
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: string code = 5
     */
    code: string; // unique code for the unit of measure. e.g. "EA", "PC", "GAL", "QT", etc.
    /**
     * @generated from protobuf field: string name = 6
     */
    name: string; // name of the unit of measure. e.g. "Each", "Piece", "Gallon", "Quart", etc.
    /**
     * @generated from protobuf field: string notes = 7
     */
    notes: string; // notes about the unit of measure.
    /**
     * @generated from protobuf field: bool is_active = 8
     */
    isActive: boolean; // whether the unit of measure is active (true) or deleted (false)
    /**
     * @generated from protobuf field: rd.company.UnitOfMeasureOrigin origin = 9
     */
    origin: UnitOfMeasureOrigin; // where this UOM originated from (e.g USER, CATALOG, etc)
    /**
     * @generated from protobuf field: rd.proto.integration_vendor.IntegrationVendor integration_vendor = 10
     */
    integrationVendor: IntegrationVendor; // not required for non-catalog items
}
/**
 * TwilioCredentials represents the credentials for a company's Twilio subaccount.
 *
 * @generated from protobuf message rd.company.TwilioCredentials
 */
export interface TwilioCredentials {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID; // company id
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 4
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: string account_sid = 5
     */
    accountSid: string;
    /**
     * @generated from protobuf field: string api_key_sid = 6
     */
    apiKeySid: string;
    /**
     * @generated from protobuf field: bytes encrypted_api_key = 7
     */
    encryptedApiKey: Uint8Array;
    /**
     * @generated from protobuf field: bytes encrypted_auth_token = 8
     */
    encryptedAuthToken: Uint8Array;
}
/**
 * PricingRegion represents a named pricing region for a company, used to group
 * locations or customers under a shared pricing context.
 *
 * @generated from protobuf message rd.company.PricingRegion
 */
export interface PricingRegion {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 2
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 3
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 4
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: string name = 5
     */
    name: string;
    /**
     * @generated from protobuf field: bool is_active = 6
     */
    isActive: boolean;
    /**
     * @generated from protobuf field: bool is_default = 7
     */
    isDefault: boolean;
    /**
     * @generated from protobuf field: int32 position = 8
     */
    position: number; // 1-indexed
}
/**
 * CustomEmailConfig represents 1 authenticated domain for a company used for
 * sending emails. Contains the SendGrid DNS records that must be set on the
 * company's DNS manager
 *
 * @generated from protobuf message rd.company.CustomEmailConfig
 */
export interface CustomEmailConfig {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 2
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: string domain = 3
     */
    domain: string;
    /**
     * @generated from protobuf field: bool enabled = 4
     */
    enabled: boolean;
    /**
     * @generated from protobuf field: rd.company.CustomEmailConfig.Status status = 5
     */
    status: CustomEmailConfig_Status;
    /**
     * @generated from protobuf field: int32 sendgrid_id = 6
     */
    sendgridId: number; // SendGrid's ID for the authenticated domain
    /**
     * @generated from protobuf field: repeated rd.company.CustomEmailConfig.DNSRecord dns_records = 7
     */
    dnsRecords: CustomEmailConfig_DNSRecord[];
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 8
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 9
     */
    updatedAt?: Timestamp;
}
/**
 * @generated from protobuf message rd.company.CustomEmailConfig.DNSRecord
 */
export interface CustomEmailConfig_DNSRecord {
    /**
     * @generated from protobuf field: rd.company.CustomEmailConfig.DNSRecord.Record name = 1
     */
    name: CustomEmailConfig_DNSRecord_Record;
    /**
     * @generated from protobuf field: bool valid = 2
     */
    valid: boolean;
    /**
     * @generated from protobuf field: string type = 3
     */
    type: string; // should be "cname"
    /**
     * @generated from protobuf field: string host = 4
     */
    host: string; // subdomain of the company's domain
    /**
     * @generated from protobuf field: string data = 5
     */
    data: string; // SendGrid subdomain
    /**
     * @generated from protobuf field: string reason = 6
     */
    reason: string;
}
/**
 * @generated from protobuf enum rd.company.CustomEmailConfig.DNSRecord.Record
 */
export enum CustomEmailConfig_DNSRecord_Record {
    /**
     * @generated from protobuf enum value: RECORD_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: RECORD_MAIL_CNAME = 1;
     */
    MAIL_CNAME = 1,
    /**
     * @generated from protobuf enum value: RECORD_DKIM1 = 2;
     */
    DKIM1 = 2,
    /**
     * @generated from protobuf enum value: RECORD_DKIM2 = 3;
     */
    DKIM2 = 3,
    /**
     * @generated from protobuf enum value: RECORD_DMARC = 4;
     */
    DMARC = 4
}
/**
 * @generated from protobuf enum rd.company.CustomEmailConfig.Status
 */
export enum CustomEmailConfig_Status {
    /**
     * @generated from protobuf enum value: STATUS_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: STATUS_INITIATED = 1;
     */
    INITIATED = 1,
    /**
     * @generated from protobuf enum value: STATUS_PENDING = 2;
     */
    PENDING = 2,
    /**
     * @generated from protobuf enum value: STATUS_VALID = 3;
     */
    VALID = 3,
    /**
     * @generated from protobuf enum value: STATUS_INVALID = 4;
     */
    INVALID = 4
}
/**
 * @generated from protobuf enum rd.company.UnitOfMeasureOrigin
 */
export enum UnitOfMeasureOrigin {
    /**
     * @generated from protobuf enum value: UOM_ORIGIN_UNSPECIFIED = 0;
     */
    UOM_ORIGIN_UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: UOM_ORIGIN_USER = 1;
     */
    UOM_ORIGIN_USER = 1,
    /**
     * @generated from protobuf enum value: UOM_ORIGIN_CATALOG = 2;
     */
    UOM_ORIGIN_CATALOG = 2,
    /**
     * created by migration parser
     *
     * @generated from protobuf enum value: UOM_ORIGIN_PARSER = 3;
     */
    UOM_ORIGIN_PARSER = 3,
    /**
     * created by an LLM tool on behalf of a user
     *
     * @generated from protobuf enum value: UOM_ORIGIN_AI = 4;
     */
    UOM_ORIGIN_AI = 4
}
// @generated message type with reflection information, may provide speed optimized methods
class Company$Type extends MessageType<Company> {
    constructor() {
        super("rd.company.Company", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "subdomain", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "pos_inactivity_timeout_minutes", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "reply_to_email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "default_quote_expiry_days", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 12, name: "logo_image_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "return_policy", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "website_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "autolock_after_checkout", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 16, name: "is_benjamin_moore_supplier", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 17, name: "should_auto_submit_ccp_rewards", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 18, name: "default_location_id", kind: "message", T: () => UUID },
            { no: 19, name: "statement_day", kind: "enum", T: () => ["rd.company.Company.StatementDay", Company_StatementDay, "STATEMENT_DAY_"] },
            { no: 20, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 21, name: "should_auto_submit_contractor_rewards", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 22, name: "contractor_rewards_bonus_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 24, name: "activated_at", kind: "message", T: () => Timestamp },
            { no: 27, name: "statement_message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 29, name: "is_discount_shown_to_customers", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 31, name: "is_color_formula_hidden", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 32, name: "is_price_shown_on_will_call", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 33, name: "is_loyalty_program_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 34, name: "loyalty_program_policy", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 35, name: "should_auto_sign_out_after_sale", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 37, name: "default_entity_id", kind: "message", T: () => UUID },
            { no: 39, name: "default_product_category_id", kind: "message", T: () => UUID },
            { no: 42, name: "is_financing_terms_shown_on_invoice", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 43, name: "statement_envelope_type", kind: "enum", T: () => ["rd.company.Company.StatementEnvelopeType", Company_StatementEnvelopeType] },
            { no: 44, name: "is_cart_reader_sync_disabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 46, name: "default_deposit_rate", kind: "message", T: () => Decimal },
            { no: 47, name: "cogs_margin_cost_basis_type", kind: "enum", T: () => ["rd.company.Company.CostBasisType", Company_CostBasisType, "COST_BASIS_TYPE_"] },
            { no: 50, name: "should_set_ordered_product_quantity_to_zero", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 51, name: "ccp_submission_cadence", kind: "enum", T: () => ["rd.company.Company.CcpSubmissionCadence", Company_CcpSubmissionCadence, "CCP_SUBMISSION_CADENCE_"] },
            { no: 52, name: "should_show_account_balance_on_receipt", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 53, name: "should_skip_linking_returns", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 54, name: "is_setting_up_new_locations", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 55, name: "is_nep_client", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 56, name: "printer_settings", kind: "message", T: () => Company_PrinterSettings },
            { no: 57, name: "should_auto_apply_return_credits", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 58, name: "preserve_sale_product_price_edits", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 59, name: "should_require_internal_sale_notes_by_default", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 60, name: "should_show_inventory_negative_warning", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 61, name: "is_discount_percentage_shown_on_receipt", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 62, name: "allow_different_fulfillment_location", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 63, name: "should_auto_apply_credits_on_statements", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 64, name: "daily_summary_prompt", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 65, name: "should_require_void_reason", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 66, name: "is_double_sided_statement_printing_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 67, name: "should_require_customer_on_sale", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 68, name: "start_inventory_counts_at_on_hand", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 69, name: "is_gift_cards_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 70, name: "country", kind: "enum", T: () => ["rd.proto.address.Address.Country", Address_Country, "COUNTRY_"] },
            { no: 71, name: "search", kind: "message", T: () => Company_Search },
            { no: 72, name: "should_show_costs_on_transfer_prints", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 73, name: "should_trigger_order_when_stock_below_min", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 74, name: "is_pricing_by_region_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 76, name: "should_hide_return_confirmation", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 77, name: "should_allow_returns_without_note", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 78, name: "ecommerce_settings", kind: "message", T: () => EcommerceSettings },
            { no: 79, name: "should_hide_all_product_images", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 80, name: "should_hide_net_zero_activities_on_statements", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 81, name: "should_hide_category_browser", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 82, name: "statement_envelope_margins", kind: "message", T: () => Company_StatementEnvelopeMargins },
            { no: 83, name: "should_allow_non_stock_price_cost_edits", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 84, name: "is_designated_clerk_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 85, name: "should_allow_non_stock_cost_edits", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 86, name: "should_match_standard_and_default_to_one_time_cost", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 87, name: "tax_rate_mode", kind: "enum", T: () => ["rd.company.Company.TaxRateMode", Company_TaxRateMode, "TAX_RATE_MODE_"] },
            { no: 88, name: "is_bm_data_sharing_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 89, name: "is_deposits_and_partial_fulfillment_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 90, name: "should_warn_when_selling_below_cost", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<Company>): Company {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.subdomain = "";
        message.posInactivityTimeoutMinutes = 0;
        message.replyToEmail = "";
        message.defaultQuoteExpiryDays = 0;
        message.logoImageUrl = "";
        message.returnPolicy = "";
        message.websiteUrl = "";
        message.autolockAfterCheckout = false;
        message.isBenjaminMooreSupplier = false;
        message.shouldAutoSubmitCcpRewards = false;
        message.statementDay = 0;
        message.isActive = false;
        message.shouldAutoSubmitContractorRewards = false;
        message.contractorRewardsBonusCode = "";
        message.statementMessage = "";
        message.isDiscountShownToCustomers = false;
        message.isColorFormulaHidden = false;
        message.isPriceShownOnWillCall = false;
        message.isLoyaltyProgramEnabled = false;
        message.loyaltyProgramPolicy = "";
        message.shouldAutoSignOutAfterSale = false;
        message.isFinancingTermsShownOnInvoice = false;
        message.statementEnvelopeType = 0;
        message.isCartReaderSyncDisabled = false;
        message.cogsMarginCostBasisType = 0;
        message.shouldSetOrderedProductQuantityToZero = false;
        message.ccpSubmissionCadence = 0;
        message.shouldShowAccountBalanceOnReceipt = false;
        message.shouldSkipLinkingReturns = false;
        message.isSettingUpNewLocations = false;
        message.isNepClient = false;
        message.shouldAutoApplyReturnCredits = false;
        message.preserveSaleProductPriceEdits = false;
        message.shouldRequireInternalSaleNotesByDefault = false;
        message.shouldShowInventoryNegativeWarning = false;
        message.isDiscountPercentageShownOnReceipt = false;
        message.allowDifferentFulfillmentLocation = false;
        message.shouldAutoApplyCreditsOnStatements = false;
        message.dailySummaryPrompt = "";
        message.shouldRequireVoidReason = false;
        message.isDoubleSidedStatementPrintingEnabled = false;
        message.shouldRequireCustomerOnSale = false;
        message.startInventoryCountsAtOnHand = false;
        message.isGiftCardsEnabled = false;
        message.country = 0;
        message.shouldTriggerOrderWhenStockBelowMin = false;
        message.isPricingByRegionEnabled = false;
        message.shouldHideReturnConfirmation = false;
        message.shouldAllowReturnsWithoutNote = false;
        message.shouldHideAllProductImages = false;
        message.shouldHideNetZeroActivitiesOnStatements = false;
        message.shouldHideCategoryBrowser = false;
        message.shouldAllowNonStockPriceCostEdits = false;
        message.isDesignatedClerkEnabled = false;
        message.shouldAllowNonStockCostEdits = false;
        message.shouldMatchStandardAndDefaultToOneTimeCost = false;
        message.taxRateMode = 0;
        message.isBmDataSharingEnabled = false;
        message.isDepositsAndPartialFulfillmentEnabled = false;
        message.shouldWarnWhenSellingBelowCost = false;
        if (value !== undefined)
            reflectionMergePartial<Company>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Company): Company {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* string name */ 4:
                    message.name = reader.string();
                    break;
                case /* string subdomain */ 5:
                    message.subdomain = reader.string();
                    break;
                case /* int32 pos_inactivity_timeout_minutes */ 6:
                    message.posInactivityTimeoutMinutes = reader.int32();
                    break;
                case /* string reply_to_email */ 7:
                    message.replyToEmail = reader.string();
                    break;
                case /* int32 default_quote_expiry_days */ 8:
                    message.defaultQuoteExpiryDays = reader.int32();
                    break;
                case /* string logo_image_url */ 12:
                    message.logoImageUrl = reader.string();
                    break;
                case /* string return_policy */ 13:
                    message.returnPolicy = reader.string();
                    break;
                case /* string website_url */ 14:
                    message.websiteUrl = reader.string();
                    break;
                case /* bool autolock_after_checkout */ 15:
                    message.autolockAfterCheckout = reader.bool();
                    break;
                case /* bool is_benjamin_moore_supplier */ 16:
                    message.isBenjaminMooreSupplier = reader.bool();
                    break;
                case /* bool should_auto_submit_ccp_rewards */ 17:
                    message.shouldAutoSubmitCcpRewards = reader.bool();
                    break;
                case /* rd.proto.uuid.UUID default_location_id */ 18:
                    message.defaultLocationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.defaultLocationId);
                    break;
                case /* rd.company.Company.StatementDay statement_day */ 19:
                    message.statementDay = reader.int32();
                    break;
                case /* bool is_active */ 20:
                    message.isActive = reader.bool();
                    break;
                case /* bool should_auto_submit_contractor_rewards */ 21:
                    message.shouldAutoSubmitContractorRewards = reader.bool();
                    break;
                case /* string contractor_rewards_bonus_code */ 22:
                    message.contractorRewardsBonusCode = reader.string();
                    break;
                case /* google.protobuf.Timestamp activated_at */ 24:
                    message.activatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.activatedAt);
                    break;
                case /* string statement_message */ 27:
                    message.statementMessage = reader.string();
                    break;
                case /* bool is_discount_shown_to_customers */ 29:
                    message.isDiscountShownToCustomers = reader.bool();
                    break;
                case /* bool is_color_formula_hidden */ 31:
                    message.isColorFormulaHidden = reader.bool();
                    break;
                case /* bool is_price_shown_on_will_call */ 32:
                    message.isPriceShownOnWillCall = reader.bool();
                    break;
                case /* bool is_loyalty_program_enabled */ 33:
                    message.isLoyaltyProgramEnabled = reader.bool();
                    break;
                case /* string loyalty_program_policy */ 34:
                    message.loyaltyProgramPolicy = reader.string();
                    break;
                case /* bool should_auto_sign_out_after_sale */ 35:
                    message.shouldAutoSignOutAfterSale = reader.bool();
                    break;
                case /* rd.proto.uuid.UUID default_entity_id */ 37:
                    message.defaultEntityId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.defaultEntityId);
                    break;
                case /* rd.proto.uuid.UUID default_product_category_id */ 39:
                    message.defaultProductCategoryId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.defaultProductCategoryId);
                    break;
                case /* bool is_financing_terms_shown_on_invoice */ 42:
                    message.isFinancingTermsShownOnInvoice = reader.bool();
                    break;
                case /* rd.company.Company.StatementEnvelopeType statement_envelope_type */ 43:
                    message.statementEnvelopeType = reader.int32();
                    break;
                case /* bool is_cart_reader_sync_disabled */ 44:
                    message.isCartReaderSyncDisabled = reader.bool();
                    break;
                case /* rd.proto.decimal.Decimal default_deposit_rate */ 46:
                    message.defaultDepositRate = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.defaultDepositRate);
                    break;
                case /* rd.company.Company.CostBasisType cogs_margin_cost_basis_type */ 47:
                    message.cogsMarginCostBasisType = reader.int32();
                    break;
                case /* bool should_set_ordered_product_quantity_to_zero */ 50:
                    message.shouldSetOrderedProductQuantityToZero = reader.bool();
                    break;
                case /* rd.company.Company.CcpSubmissionCadence ccp_submission_cadence */ 51:
                    message.ccpSubmissionCadence = reader.int32();
                    break;
                case /* bool should_show_account_balance_on_receipt */ 52:
                    message.shouldShowAccountBalanceOnReceipt = reader.bool();
                    break;
                case /* bool should_skip_linking_returns */ 53:
                    message.shouldSkipLinkingReturns = reader.bool();
                    break;
                case /* bool is_setting_up_new_locations */ 54:
                    message.isSettingUpNewLocations = reader.bool();
                    break;
                case /* bool is_nep_client */ 55:
                    message.isNepClient = reader.bool();
                    break;
                case /* rd.company.Company.PrinterSettings printer_settings */ 56:
                    message.printerSettings = Company_PrinterSettings.internalBinaryRead(reader, reader.uint32(), options, message.printerSettings);
                    break;
                case /* bool should_auto_apply_return_credits */ 57:
                    message.shouldAutoApplyReturnCredits = reader.bool();
                    break;
                case /* bool preserve_sale_product_price_edits */ 58:
                    message.preserveSaleProductPriceEdits = reader.bool();
                    break;
                case /* bool should_require_internal_sale_notes_by_default */ 59:
                    message.shouldRequireInternalSaleNotesByDefault = reader.bool();
                    break;
                case /* bool should_show_inventory_negative_warning */ 60:
                    message.shouldShowInventoryNegativeWarning = reader.bool();
                    break;
                case /* bool is_discount_percentage_shown_on_receipt */ 61:
                    message.isDiscountPercentageShownOnReceipt = reader.bool();
                    break;
                case /* bool allow_different_fulfillment_location */ 62:
                    message.allowDifferentFulfillmentLocation = reader.bool();
                    break;
                case /* bool should_auto_apply_credits_on_statements */ 63:
                    message.shouldAutoApplyCreditsOnStatements = reader.bool();
                    break;
                case /* string daily_summary_prompt */ 64:
                    message.dailySummaryPrompt = reader.string();
                    break;
                case /* bool should_require_void_reason */ 65:
                    message.shouldRequireVoidReason = reader.bool();
                    break;
                case /* bool is_double_sided_statement_printing_enabled */ 66:
                    message.isDoubleSidedStatementPrintingEnabled = reader.bool();
                    break;
                case /* bool should_require_customer_on_sale */ 67:
                    message.shouldRequireCustomerOnSale = reader.bool();
                    break;
                case /* bool start_inventory_counts_at_on_hand */ 68:
                    message.startInventoryCountsAtOnHand = reader.bool();
                    break;
                case /* bool is_gift_cards_enabled */ 69:
                    message.isGiftCardsEnabled = reader.bool();
                    break;
                case /* rd.proto.address.Address.Country country */ 70:
                    message.country = reader.int32();
                    break;
                case /* rd.company.Company.Search search */ 71:
                    message.search = Company_Search.internalBinaryRead(reader, reader.uint32(), options, message.search);
                    break;
                case /* optional bool should_show_costs_on_transfer_prints */ 72:
                    message.shouldShowCostsOnTransferPrints = reader.bool();
                    break;
                case /* bool should_trigger_order_when_stock_below_min */ 73:
                    message.shouldTriggerOrderWhenStockBelowMin = reader.bool();
                    break;
                case /* bool is_pricing_by_region_enabled */ 74:
                    message.isPricingByRegionEnabled = reader.bool();
                    break;
                case /* bool should_hide_return_confirmation */ 76:
                    message.shouldHideReturnConfirmation = reader.bool();
                    break;
                case /* bool should_allow_returns_without_note */ 77:
                    message.shouldAllowReturnsWithoutNote = reader.bool();
                    break;
                case /* rd.company.EcommerceSettings ecommerce_settings */ 78:
                    message.ecommerceSettings = EcommerceSettings.internalBinaryRead(reader, reader.uint32(), options, message.ecommerceSettings);
                    break;
                case /* bool should_hide_all_product_images */ 79:
                    message.shouldHideAllProductImages = reader.bool();
                    break;
                case /* bool should_hide_net_zero_activities_on_statements */ 80:
                    message.shouldHideNetZeroActivitiesOnStatements = reader.bool();
                    break;
                case /* bool should_hide_category_browser */ 81:
                    message.shouldHideCategoryBrowser = reader.bool();
                    break;
                case /* rd.company.Company.StatementEnvelopeMargins statement_envelope_margins */ 82:
                    message.statementEnvelopeMargins = Company_StatementEnvelopeMargins.internalBinaryRead(reader, reader.uint32(), options, message.statementEnvelopeMargins);
                    break;
                case /* bool should_allow_non_stock_price_cost_edits */ 83:
                    message.shouldAllowNonStockPriceCostEdits = reader.bool();
                    break;
                case /* bool is_designated_clerk_enabled */ 84:
                    message.isDesignatedClerkEnabled = reader.bool();
                    break;
                case /* bool should_allow_non_stock_cost_edits */ 85:
                    message.shouldAllowNonStockCostEdits = reader.bool();
                    break;
                case /* bool should_match_standard_and_default_to_one_time_cost */ 86:
                    message.shouldMatchStandardAndDefaultToOneTimeCost = reader.bool();
                    break;
                case /* rd.company.Company.TaxRateMode tax_rate_mode */ 87:
                    message.taxRateMode = reader.int32();
                    break;
                case /* bool is_bm_data_sharing_enabled */ 88:
                    message.isBmDataSharingEnabled = reader.bool();
                    break;
                case /* bool is_deposits_and_partial_fulfillment_enabled */ 89:
                    message.isDepositsAndPartialFulfillmentEnabled = reader.bool();
                    break;
                case /* bool should_warn_when_selling_below_cost */ 90:
                    message.shouldWarnWhenSellingBelowCost = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Company, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string name = 4; */
        if (message.name !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.name);
        /* string subdomain = 5; */
        if (message.subdomain !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.subdomain);
        /* int32 pos_inactivity_timeout_minutes = 6; */
        if (message.posInactivityTimeoutMinutes !== 0)
            writer.tag(6, WireType.Varint).int32(message.posInactivityTimeoutMinutes);
        /* string reply_to_email = 7; */
        if (message.replyToEmail !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.replyToEmail);
        /* int32 default_quote_expiry_days = 8; */
        if (message.defaultQuoteExpiryDays !== 0)
            writer.tag(8, WireType.Varint).int32(message.defaultQuoteExpiryDays);
        /* string logo_image_url = 12; */
        if (message.logoImageUrl !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.logoImageUrl);
        /* string return_policy = 13; */
        if (message.returnPolicy !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.returnPolicy);
        /* string website_url = 14; */
        if (message.websiteUrl !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.websiteUrl);
        /* bool autolock_after_checkout = 15; */
        if (message.autolockAfterCheckout !== false)
            writer.tag(15, WireType.Varint).bool(message.autolockAfterCheckout);
        /* bool is_benjamin_moore_supplier = 16; */
        if (message.isBenjaminMooreSupplier !== false)
            writer.tag(16, WireType.Varint).bool(message.isBenjaminMooreSupplier);
        /* bool should_auto_submit_ccp_rewards = 17; */
        if (message.shouldAutoSubmitCcpRewards !== false)
            writer.tag(17, WireType.Varint).bool(message.shouldAutoSubmitCcpRewards);
        /* rd.proto.uuid.UUID default_location_id = 18; */
        if (message.defaultLocationId)
            UUID.internalBinaryWrite(message.defaultLocationId, writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.Company.StatementDay statement_day = 19; */
        if (message.statementDay !== 0)
            writer.tag(19, WireType.Varint).int32(message.statementDay);
        /* bool is_active = 20; */
        if (message.isActive !== false)
            writer.tag(20, WireType.Varint).bool(message.isActive);
        /* bool should_auto_submit_contractor_rewards = 21; */
        if (message.shouldAutoSubmitContractorRewards !== false)
            writer.tag(21, WireType.Varint).bool(message.shouldAutoSubmitContractorRewards);
        /* string contractor_rewards_bonus_code = 22; */
        if (message.contractorRewardsBonusCode !== "")
            writer.tag(22, WireType.LengthDelimited).string(message.contractorRewardsBonusCode);
        /* google.protobuf.Timestamp activated_at = 24; */
        if (message.activatedAt)
            Timestamp.internalBinaryWrite(message.activatedAt, writer.tag(24, WireType.LengthDelimited).fork(), options).join();
        /* string statement_message = 27; */
        if (message.statementMessage !== "")
            writer.tag(27, WireType.LengthDelimited).string(message.statementMessage);
        /* bool is_discount_shown_to_customers = 29; */
        if (message.isDiscountShownToCustomers !== false)
            writer.tag(29, WireType.Varint).bool(message.isDiscountShownToCustomers);
        /* bool is_color_formula_hidden = 31; */
        if (message.isColorFormulaHidden !== false)
            writer.tag(31, WireType.Varint).bool(message.isColorFormulaHidden);
        /* bool is_price_shown_on_will_call = 32; */
        if (message.isPriceShownOnWillCall !== false)
            writer.tag(32, WireType.Varint).bool(message.isPriceShownOnWillCall);
        /* bool is_loyalty_program_enabled = 33; */
        if (message.isLoyaltyProgramEnabled !== false)
            writer.tag(33, WireType.Varint).bool(message.isLoyaltyProgramEnabled);
        /* string loyalty_program_policy = 34; */
        if (message.loyaltyProgramPolicy !== "")
            writer.tag(34, WireType.LengthDelimited).string(message.loyaltyProgramPolicy);
        /* bool should_auto_sign_out_after_sale = 35; */
        if (message.shouldAutoSignOutAfterSale !== false)
            writer.tag(35, WireType.Varint).bool(message.shouldAutoSignOutAfterSale);
        /* rd.proto.uuid.UUID default_entity_id = 37; */
        if (message.defaultEntityId)
            UUID.internalBinaryWrite(message.defaultEntityId, writer.tag(37, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID default_product_category_id = 39; */
        if (message.defaultProductCategoryId)
            UUID.internalBinaryWrite(message.defaultProductCategoryId, writer.tag(39, WireType.LengthDelimited).fork(), options).join();
        /* bool is_financing_terms_shown_on_invoice = 42; */
        if (message.isFinancingTermsShownOnInvoice !== false)
            writer.tag(42, WireType.Varint).bool(message.isFinancingTermsShownOnInvoice);
        /* rd.company.Company.StatementEnvelopeType statement_envelope_type = 43; */
        if (message.statementEnvelopeType !== 0)
            writer.tag(43, WireType.Varint).int32(message.statementEnvelopeType);
        /* bool is_cart_reader_sync_disabled = 44; */
        if (message.isCartReaderSyncDisabled !== false)
            writer.tag(44, WireType.Varint).bool(message.isCartReaderSyncDisabled);
        /* rd.proto.decimal.Decimal default_deposit_rate = 46; */
        if (message.defaultDepositRate)
            Decimal.internalBinaryWrite(message.defaultDepositRate, writer.tag(46, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.Company.CostBasisType cogs_margin_cost_basis_type = 47; */
        if (message.cogsMarginCostBasisType !== 0)
            writer.tag(47, WireType.Varint).int32(message.cogsMarginCostBasisType);
        /* bool should_set_ordered_product_quantity_to_zero = 50; */
        if (message.shouldSetOrderedProductQuantityToZero !== false)
            writer.tag(50, WireType.Varint).bool(message.shouldSetOrderedProductQuantityToZero);
        /* rd.company.Company.CcpSubmissionCadence ccp_submission_cadence = 51; */
        if (message.ccpSubmissionCadence !== 0)
            writer.tag(51, WireType.Varint).int32(message.ccpSubmissionCadence);
        /* bool should_show_account_balance_on_receipt = 52; */
        if (message.shouldShowAccountBalanceOnReceipt !== false)
            writer.tag(52, WireType.Varint).bool(message.shouldShowAccountBalanceOnReceipt);
        /* bool should_skip_linking_returns = 53; */
        if (message.shouldSkipLinkingReturns !== false)
            writer.tag(53, WireType.Varint).bool(message.shouldSkipLinkingReturns);
        /* bool is_setting_up_new_locations = 54; */
        if (message.isSettingUpNewLocations !== false)
            writer.tag(54, WireType.Varint).bool(message.isSettingUpNewLocations);
        /* bool is_nep_client = 55; */
        if (message.isNepClient !== false)
            writer.tag(55, WireType.Varint).bool(message.isNepClient);
        /* rd.company.Company.PrinterSettings printer_settings = 56; */
        if (message.printerSettings)
            Company_PrinterSettings.internalBinaryWrite(message.printerSettings, writer.tag(56, WireType.LengthDelimited).fork(), options).join();
        /* bool should_auto_apply_return_credits = 57; */
        if (message.shouldAutoApplyReturnCredits !== false)
            writer.tag(57, WireType.Varint).bool(message.shouldAutoApplyReturnCredits);
        /* bool preserve_sale_product_price_edits = 58; */
        if (message.preserveSaleProductPriceEdits !== false)
            writer.tag(58, WireType.Varint).bool(message.preserveSaleProductPriceEdits);
        /* bool should_require_internal_sale_notes_by_default = 59; */
        if (message.shouldRequireInternalSaleNotesByDefault !== false)
            writer.tag(59, WireType.Varint).bool(message.shouldRequireInternalSaleNotesByDefault);
        /* bool should_show_inventory_negative_warning = 60; */
        if (message.shouldShowInventoryNegativeWarning !== false)
            writer.tag(60, WireType.Varint).bool(message.shouldShowInventoryNegativeWarning);
        /* bool is_discount_percentage_shown_on_receipt = 61; */
        if (message.isDiscountPercentageShownOnReceipt !== false)
            writer.tag(61, WireType.Varint).bool(message.isDiscountPercentageShownOnReceipt);
        /* bool allow_different_fulfillment_location = 62; */
        if (message.allowDifferentFulfillmentLocation !== false)
            writer.tag(62, WireType.Varint).bool(message.allowDifferentFulfillmentLocation);
        /* bool should_auto_apply_credits_on_statements = 63; */
        if (message.shouldAutoApplyCreditsOnStatements !== false)
            writer.tag(63, WireType.Varint).bool(message.shouldAutoApplyCreditsOnStatements);
        /* string daily_summary_prompt = 64; */
        if (message.dailySummaryPrompt !== "")
            writer.tag(64, WireType.LengthDelimited).string(message.dailySummaryPrompt);
        /* bool should_require_void_reason = 65; */
        if (message.shouldRequireVoidReason !== false)
            writer.tag(65, WireType.Varint).bool(message.shouldRequireVoidReason);
        /* bool is_double_sided_statement_printing_enabled = 66; */
        if (message.isDoubleSidedStatementPrintingEnabled !== false)
            writer.tag(66, WireType.Varint).bool(message.isDoubleSidedStatementPrintingEnabled);
        /* bool should_require_customer_on_sale = 67; */
        if (message.shouldRequireCustomerOnSale !== false)
            writer.tag(67, WireType.Varint).bool(message.shouldRequireCustomerOnSale);
        /* bool start_inventory_counts_at_on_hand = 68; */
        if (message.startInventoryCountsAtOnHand !== false)
            writer.tag(68, WireType.Varint).bool(message.startInventoryCountsAtOnHand);
        /* bool is_gift_cards_enabled = 69; */
        if (message.isGiftCardsEnabled !== false)
            writer.tag(69, WireType.Varint).bool(message.isGiftCardsEnabled);
        /* rd.proto.address.Address.Country country = 70; */
        if (message.country !== 0)
            writer.tag(70, WireType.Varint).int32(message.country);
        /* rd.company.Company.Search search = 71; */
        if (message.search)
            Company_Search.internalBinaryWrite(message.search, writer.tag(71, WireType.LengthDelimited).fork(), options).join();
        /* optional bool should_show_costs_on_transfer_prints = 72; */
        if (message.shouldShowCostsOnTransferPrints !== undefined)
            writer.tag(72, WireType.Varint).bool(message.shouldShowCostsOnTransferPrints);
        /* bool should_trigger_order_when_stock_below_min = 73; */
        if (message.shouldTriggerOrderWhenStockBelowMin !== false)
            writer.tag(73, WireType.Varint).bool(message.shouldTriggerOrderWhenStockBelowMin);
        /* bool is_pricing_by_region_enabled = 74; */
        if (message.isPricingByRegionEnabled !== false)
            writer.tag(74, WireType.Varint).bool(message.isPricingByRegionEnabled);
        /* bool should_hide_return_confirmation = 76; */
        if (message.shouldHideReturnConfirmation !== false)
            writer.tag(76, WireType.Varint).bool(message.shouldHideReturnConfirmation);
        /* bool should_allow_returns_without_note = 77; */
        if (message.shouldAllowReturnsWithoutNote !== false)
            writer.tag(77, WireType.Varint).bool(message.shouldAllowReturnsWithoutNote);
        /* rd.company.EcommerceSettings ecommerce_settings = 78; */
        if (message.ecommerceSettings)
            EcommerceSettings.internalBinaryWrite(message.ecommerceSettings, writer.tag(78, WireType.LengthDelimited).fork(), options).join();
        /* bool should_hide_all_product_images = 79; */
        if (message.shouldHideAllProductImages !== false)
            writer.tag(79, WireType.Varint).bool(message.shouldHideAllProductImages);
        /* bool should_hide_net_zero_activities_on_statements = 80; */
        if (message.shouldHideNetZeroActivitiesOnStatements !== false)
            writer.tag(80, WireType.Varint).bool(message.shouldHideNetZeroActivitiesOnStatements);
        /* bool should_hide_category_browser = 81; */
        if (message.shouldHideCategoryBrowser !== false)
            writer.tag(81, WireType.Varint).bool(message.shouldHideCategoryBrowser);
        /* rd.company.Company.StatementEnvelopeMargins statement_envelope_margins = 82; */
        if (message.statementEnvelopeMargins)
            Company_StatementEnvelopeMargins.internalBinaryWrite(message.statementEnvelopeMargins, writer.tag(82, WireType.LengthDelimited).fork(), options).join();
        /* bool should_allow_non_stock_price_cost_edits = 83; */
        if (message.shouldAllowNonStockPriceCostEdits !== false)
            writer.tag(83, WireType.Varint).bool(message.shouldAllowNonStockPriceCostEdits);
        /* bool is_designated_clerk_enabled = 84; */
        if (message.isDesignatedClerkEnabled !== false)
            writer.tag(84, WireType.Varint).bool(message.isDesignatedClerkEnabled);
        /* bool should_allow_non_stock_cost_edits = 85; */
        if (message.shouldAllowNonStockCostEdits !== false)
            writer.tag(85, WireType.Varint).bool(message.shouldAllowNonStockCostEdits);
        /* bool should_match_standard_and_default_to_one_time_cost = 86; */
        if (message.shouldMatchStandardAndDefaultToOneTimeCost !== false)
            writer.tag(86, WireType.Varint).bool(message.shouldMatchStandardAndDefaultToOneTimeCost);
        /* rd.company.Company.TaxRateMode tax_rate_mode = 87; */
        if (message.taxRateMode !== 0)
            writer.tag(87, WireType.Varint).int32(message.taxRateMode);
        /* bool is_bm_data_sharing_enabled = 88; */
        if (message.isBmDataSharingEnabled !== false)
            writer.tag(88, WireType.Varint).bool(message.isBmDataSharingEnabled);
        /* bool is_deposits_and_partial_fulfillment_enabled = 89; */
        if (message.isDepositsAndPartialFulfillmentEnabled !== false)
            writer.tag(89, WireType.Varint).bool(message.isDepositsAndPartialFulfillmentEnabled);
        /* bool should_warn_when_selling_below_cost = 90; */
        if (message.shouldWarnWhenSellingBelowCost !== false)
            writer.tag(90, WireType.Varint).bool(message.shouldWarnWhenSellingBelowCost);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.company.Company
 */
export const Company = new Company$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Company_PrinterSettings$Type extends MessageType<Company_PrinterSettings> {
    constructor() {
        super("rd.company.Company.PrinterSettings", [
            { no: 1, name: "default_receipt_quantity", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "should_quick_print_thermal", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "should_quick_print_full_page", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "quick_print_show_prices", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "settings_by_location_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Company_PrinterSettings_LocationSettings } },
            { no: 7, name: "should_auto_print_new_sales_and_receivables", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "should_auto_print_completed_sales_and_receivables", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<Company_PrinterSettings>): Company_PrinterSettings {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.defaultReceiptQuantity = 0;
        message.shouldQuickPrintThermal = false;
        message.shouldQuickPrintFullPage = false;
        message.quickPrintShowPrices = false;
        message.settingsByLocationId = {};
        message.shouldAutoPrintNewSalesAndReceivables = false;
        message.shouldAutoPrintCompletedSalesAndReceivables = false;
        if (value !== undefined)
            reflectionMergePartial<Company_PrinterSettings>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Company_PrinterSettings): Company_PrinterSettings {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 default_receipt_quantity */ 1:
                    message.defaultReceiptQuantity = reader.int32();
                    break;
                case /* bool should_quick_print_thermal */ 3:
                    message.shouldQuickPrintThermal = reader.bool();
                    break;
                case /* bool should_quick_print_full_page */ 4:
                    message.shouldQuickPrintFullPage = reader.bool();
                    break;
                case /* bool quick_print_show_prices */ 5:
                    message.quickPrintShowPrices = reader.bool();
                    break;
                case /* map<string, rd.company.Company.PrinterSettings.LocationSettings> settings_by_location_id */ 6:
                    this.binaryReadMap6(message.settingsByLocationId, reader, options);
                    break;
                case /* bool should_auto_print_new_sales_and_receivables */ 7:
                    message.shouldAutoPrintNewSalesAndReceivables = reader.bool();
                    break;
                case /* bool should_auto_print_completed_sales_and_receivables */ 8:
                    message.shouldAutoPrintCompletedSalesAndReceivables = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap6(map: Company_PrinterSettings["settingsByLocationId"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof Company_PrinterSettings["settingsByLocationId"] | undefined, val: Company_PrinterSettings["settingsByLocationId"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Company_PrinterSettings_LocationSettings.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.company.Company.PrinterSettings.settings_by_location_id");
            }
        }
        map[key ?? ""] = val ?? Company_PrinterSettings_LocationSettings.create();
    }
    internalBinaryWrite(message: Company_PrinterSettings, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 default_receipt_quantity = 1; */
        if (message.defaultReceiptQuantity !== 0)
            writer.tag(1, WireType.Varint).int32(message.defaultReceiptQuantity);
        /* bool should_quick_print_thermal = 3; */
        if (message.shouldQuickPrintThermal !== false)
            writer.tag(3, WireType.Varint).bool(message.shouldQuickPrintThermal);
        /* bool should_quick_print_full_page = 4; */
        if (message.shouldQuickPrintFullPage !== false)
            writer.tag(4, WireType.Varint).bool(message.shouldQuickPrintFullPage);
        /* bool quick_print_show_prices = 5; */
        if (message.quickPrintShowPrices !== false)
            writer.tag(5, WireType.Varint).bool(message.quickPrintShowPrices);
        /* map<string, rd.company.Company.PrinterSettings.LocationSettings> settings_by_location_id = 6; */
        for (let k of globalThis.Object.keys(message.settingsByLocationId)) {
            writer.tag(6, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Company_PrinterSettings_LocationSettings.internalBinaryWrite(message.settingsByLocationId[k], writer, options);
            writer.join().join();
        }
        /* bool should_auto_print_new_sales_and_receivables = 7; */
        if (message.shouldAutoPrintNewSalesAndReceivables !== false)
            writer.tag(7, WireType.Varint).bool(message.shouldAutoPrintNewSalesAndReceivables);
        /* bool should_auto_print_completed_sales_and_receivables = 8; */
        if (message.shouldAutoPrintCompletedSalesAndReceivables !== false)
            writer.tag(8, WireType.Varint).bool(message.shouldAutoPrintCompletedSalesAndReceivables);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.company.Company.PrinterSettings
 */
export const Company_PrinterSettings = new Company_PrinterSettings$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Company_PrinterSettings_LocationSettings$Type extends MessageType<Company_PrinterSettings_LocationSettings> {
    constructor() {
        super("rd.company.Company.PrinterSettings.LocationSettings", [
            { no: 1, name: "quick_print_printer_id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<Company_PrinterSettings_LocationSettings>): Company_PrinterSettings_LocationSettings {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<Company_PrinterSettings_LocationSettings>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Company_PrinterSettings_LocationSettings): Company_PrinterSettings_LocationSettings {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID quick_print_printer_id */ 1:
                    message.quickPrintPrinterId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.quickPrintPrinterId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Company_PrinterSettings_LocationSettings, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID quick_print_printer_id = 1; */
        if (message.quickPrintPrinterId)
            UUID.internalBinaryWrite(message.quickPrintPrinterId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.company.Company.PrinterSettings.LocationSettings
 */
export const Company_PrinterSettings_LocationSettings = new Company_PrinterSettings_LocationSettings$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Company_Search$Type extends MessageType<Company_Search> {
    constructor() {
        super("rd.company.Company.Search", [
            { no: 1, name: "size_GB", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "is_size_overridden", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "domain", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "replicas", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 5, name: "replicas_start_cron", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "replicas_end_cron", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Company_Search>): Company_Search {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sizeGB = 0;
        message.isSizeOverridden = false;
        message.domain = "";
        message.replicas = 0n;
        message.replicasStartCron = "";
        message.replicasEndCron = "";
        if (value !== undefined)
            reflectionMergePartial<Company_Search>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Company_Search): Company_Search {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* double size_GB */ 1:
                    message.sizeGB = reader.double();
                    break;
                case /* bool is_size_overridden */ 2:
                    message.isSizeOverridden = reader.bool();
                    break;
                case /* string domain */ 3:
                    message.domain = reader.string();
                    break;
                case /* int64 replicas */ 4:
                    message.replicas = reader.int64().toBigInt();
                    break;
                case /* string replicas_start_cron */ 5:
                    message.replicasStartCron = reader.string();
                    break;
                case /* string replicas_end_cron */ 6:
                    message.replicasEndCron = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Company_Search, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* double size_GB = 1; */
        if (message.sizeGB !== 0)
            writer.tag(1, WireType.Bit64).double(message.sizeGB);
        /* bool is_size_overridden = 2; */
        if (message.isSizeOverridden !== false)
            writer.tag(2, WireType.Varint).bool(message.isSizeOverridden);
        /* string domain = 3; */
        if (message.domain !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.domain);
        /* int64 replicas = 4; */
        if (message.replicas !== 0n)
            writer.tag(4, WireType.Varint).int64(message.replicas);
        /* string replicas_start_cron = 5; */
        if (message.replicasStartCron !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.replicasStartCron);
        /* string replicas_end_cron = 6; */
        if (message.replicasEndCron !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.replicasEndCron);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.company.Company.Search
 */
export const Company_Search = new Company_Search$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Company_StatementEnvelopeMargins$Type extends MessageType<Company_StatementEnvelopeMargins> {
    constructor() {
        super("rd.company.Company.StatementEnvelopeMargins", [
            { no: 1, name: "from_address_top_margin", kind: "message", T: () => Decimal },
            { no: 2, name: "from_address_left_margin", kind: "message", T: () => Decimal },
            { no: 3, name: "to_address_top_margin", kind: "message", T: () => Decimal },
            { no: 4, name: "to_address_left_margin", kind: "message", T: () => Decimal }
        ]);
    }
    create(value?: PartialMessage<Company_StatementEnvelopeMargins>): Company_StatementEnvelopeMargins {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<Company_StatementEnvelopeMargins>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Company_StatementEnvelopeMargins): Company_StatementEnvelopeMargins {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.decimal.Decimal from_address_top_margin */ 1:
                    message.fromAddressTopMargin = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.fromAddressTopMargin);
                    break;
                case /* rd.proto.decimal.Decimal from_address_left_margin */ 2:
                    message.fromAddressLeftMargin = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.fromAddressLeftMargin);
                    break;
                case /* rd.proto.decimal.Decimal to_address_top_margin */ 3:
                    message.toAddressTopMargin = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.toAddressTopMargin);
                    break;
                case /* rd.proto.decimal.Decimal to_address_left_margin */ 4:
                    message.toAddressLeftMargin = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.toAddressLeftMargin);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Company_StatementEnvelopeMargins, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.decimal.Decimal from_address_top_margin = 1; */
        if (message.fromAddressTopMargin)
            Decimal.internalBinaryWrite(message.fromAddressTopMargin, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal from_address_left_margin = 2; */
        if (message.fromAddressLeftMargin)
            Decimal.internalBinaryWrite(message.fromAddressLeftMargin, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal to_address_top_margin = 3; */
        if (message.toAddressTopMargin)
            Decimal.internalBinaryWrite(message.toAddressTopMargin, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal to_address_left_margin = 4; */
        if (message.toAddressLeftMargin)
            Decimal.internalBinaryWrite(message.toAddressLeftMargin, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.company.Company.StatementEnvelopeMargins
 */
export const Company_StatementEnvelopeMargins = new Company_StatementEnvelopeMargins$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EcommerceSettings$Type extends MessageType<EcommerceSettings> {
    constructor() {
        super("rd.company.EcommerceSettings", [
            { no: 1, name: "is_ecomm_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "settings_by_location_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => EcommerceSettings_LocationSettings } }
        ]);
    }
    create(value?: PartialMessage<EcommerceSettings>): EcommerceSettings {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isEcommEnabled = false;
        message.settingsByLocationId = {};
        if (value !== undefined)
            reflectionMergePartial<EcommerceSettings>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EcommerceSettings): EcommerceSettings {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool is_ecomm_enabled */ 1:
                    message.isEcommEnabled = reader.bool();
                    break;
                case /* map<string, rd.company.EcommerceSettings.LocationSettings> settings_by_location_id */ 3:
                    this.binaryReadMap3(message.settingsByLocationId, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap3(map: EcommerceSettings["settingsByLocationId"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof EcommerceSettings["settingsByLocationId"] | undefined, val: EcommerceSettings["settingsByLocationId"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = EcommerceSettings_LocationSettings.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.company.EcommerceSettings.settings_by_location_id");
            }
        }
        map[key ?? ""] = val ?? EcommerceSettings_LocationSettings.create();
    }
    internalBinaryWrite(message: EcommerceSettings, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool is_ecomm_enabled = 1; */
        if (message.isEcommEnabled !== false)
            writer.tag(1, WireType.Varint).bool(message.isEcommEnabled);
        /* map<string, rd.company.EcommerceSettings.LocationSettings> settings_by_location_id = 3; */
        for (let k of globalThis.Object.keys(message.settingsByLocationId)) {
            writer.tag(3, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            EcommerceSettings_LocationSettings.internalBinaryWrite(message.settingsByLocationId[k], writer, options);
            writer.join().join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.company.EcommerceSettings
 */
export const EcommerceSettings = new EcommerceSettings$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EcommerceSettings_LocationSettings$Type extends MessageType<EcommerceSettings_LocationSettings> {
    constructor() {
        super("rd.company.EcommerceSettings.LocationSettings", [
            { no: 1, name: "receipt_printer_id", kind: "message", T: () => UUID },
            { no: 2, name: "ignore_inventory_levels", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<EcommerceSettings_LocationSettings>): EcommerceSettings_LocationSettings {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.ignoreInventoryLevels = false;
        if (value !== undefined)
            reflectionMergePartial<EcommerceSettings_LocationSettings>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EcommerceSettings_LocationSettings): EcommerceSettings_LocationSettings {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID receipt_printer_id */ 1:
                    message.receiptPrinterId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.receiptPrinterId);
                    break;
                case /* bool ignore_inventory_levels */ 2:
                    message.ignoreInventoryLevels = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EcommerceSettings_LocationSettings, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID receipt_printer_id = 1; */
        if (message.receiptPrinterId)
            UUID.internalBinaryWrite(message.receiptPrinterId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool ignore_inventory_levels = 2; */
        if (message.ignoreInventoryLevels !== false)
            writer.tag(2, WireType.Varint).bool(message.ignoreInventoryLevels);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.company.EcommerceSettings.LocationSettings
 */
export const EcommerceSettings_LocationSettings = new EcommerceSettings_LocationSettings$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Location$Type extends MessageType<Location> {
    constructor() {
        super("rd.company.Location", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "company_id", kind: "message", T: () => UUID },
            { no: 5, name: "prefix", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "phone", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "address", kind: "message", T: () => Address },
            { no: 9, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "time_zone", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "stripe_location_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "bm_outlet_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "entity_id", kind: "message", T: () => UUID },
            { no: 16, name: "reply_to_email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 17, name: "logo_image_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 18, name: "google_review_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 19, name: "quickbooks_class", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 20, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 21, name: "statement_message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 22, name: "cc_on_emails", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 23, name: "twilio_phone", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 24, name: "outbound_email", kind: "message", T: () => Location_OutboundEmail },
            { no: 25, name: "pricing_region_id", kind: "message", T: () => UUID },
            { no: 26, name: "cash_rounding", kind: "message", T: () => CashRounding },
            { no: 27, name: "show_inventory", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<Location>): Location {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.prefix = "";
        message.name = "";
        message.phone = "";
        message.isActive = false;
        message.timeZone = "";
        message.stripeLocationId = "";
        message.bmOutletNumber = "";
        message.replyToEmail = "";
        message.logoImageUrl = "";
        message.googleReviewUrl = "";
        message.quickbooksClass = "";
        message.displayName = "";
        message.statementMessage = "";
        message.ccOnEmails = false;
        message.twilioPhone = "";
        message.showInventory = false;
        if (value !== undefined)
            reflectionMergePartial<Location>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Location): Location {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 4:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* string prefix */ 5:
                    message.prefix = reader.string();
                    break;
                case /* string name */ 6:
                    message.name = reader.string();
                    break;
                case /* string phone */ 7:
                    message.phone = reader.string();
                    break;
                case /* rd.proto.address.Address address */ 8:
                    message.address = Address.internalBinaryRead(reader, reader.uint32(), options, message.address);
                    break;
                case /* bool is_active */ 9:
                    message.isActive = reader.bool();
                    break;
                case /* string time_zone */ 10:
                    message.timeZone = reader.string();
                    break;
                case /* string stripe_location_id */ 11:
                    message.stripeLocationId = reader.string();
                    break;
                case /* string bm_outlet_number */ 13:
                    message.bmOutletNumber = reader.string();
                    break;
                case /* rd.proto.uuid.UUID entity_id */ 15:
                    message.entityId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.entityId);
                    break;
                case /* string reply_to_email */ 16:
                    message.replyToEmail = reader.string();
                    break;
                case /* string logo_image_url */ 17:
                    message.logoImageUrl = reader.string();
                    break;
                case /* string google_review_url */ 18:
                    message.googleReviewUrl = reader.string();
                    break;
                case /* string quickbooks_class */ 19:
                    message.quickbooksClass = reader.string();
                    break;
                case /* string display_name */ 20:
                    message.displayName = reader.string();
                    break;
                case /* string statement_message */ 21:
                    message.statementMessage = reader.string();
                    break;
                case /* bool cc_on_emails */ 22:
                    message.ccOnEmails = reader.bool();
                    break;
                case /* string twilio_phone */ 23:
                    message.twilioPhone = reader.string();
                    break;
                case /* rd.company.Location.OutboundEmail outbound_email */ 24:
                    message.outboundEmail = Location_OutboundEmail.internalBinaryRead(reader, reader.uint32(), options, message.outboundEmail);
                    break;
                case /* rd.proto.uuid.UUID pricing_region_id */ 25:
                    message.pricingRegionId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.pricingRegionId);
                    break;
                case /* rd.proto.money.CashRounding cash_rounding */ 26:
                    message.cashRounding = CashRounding.internalBinaryRead(reader, reader.uint32(), options, message.cashRounding);
                    break;
                case /* bool show_inventory */ 27:
                    message.showInventory = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Location, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 4; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string prefix = 5; */
        if (message.prefix !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.prefix);
        /* string name = 6; */
        if (message.name !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.name);
        /* string phone = 7; */
        if (message.phone !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.phone);
        /* rd.proto.address.Address address = 8; */
        if (message.address)
            Address.internalBinaryWrite(message.address, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* bool is_active = 9; */
        if (message.isActive !== false)
            writer.tag(9, WireType.Varint).bool(message.isActive);
        /* string time_zone = 10; */
        if (message.timeZone !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.timeZone);
        /* string stripe_location_id = 11; */
        if (message.stripeLocationId !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.stripeLocationId);
        /* string bm_outlet_number = 13; */
        if (message.bmOutletNumber !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.bmOutletNumber);
        /* rd.proto.uuid.UUID entity_id = 15; */
        if (message.entityId)
            UUID.internalBinaryWrite(message.entityId, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* string reply_to_email = 16; */
        if (message.replyToEmail !== "")
            writer.tag(16, WireType.LengthDelimited).string(message.replyToEmail);
        /* string logo_image_url = 17; */
        if (message.logoImageUrl !== "")
            writer.tag(17, WireType.LengthDelimited).string(message.logoImageUrl);
        /* string google_review_url = 18; */
        if (message.googleReviewUrl !== "")
            writer.tag(18, WireType.LengthDelimited).string(message.googleReviewUrl);
        /* string quickbooks_class = 19; */
        if (message.quickbooksClass !== "")
            writer.tag(19, WireType.LengthDelimited).string(message.quickbooksClass);
        /* string display_name = 20; */
        if (message.displayName !== "")
            writer.tag(20, WireType.LengthDelimited).string(message.displayName);
        /* string statement_message = 21; */
        if (message.statementMessage !== "")
            writer.tag(21, WireType.LengthDelimited).string(message.statementMessage);
        /* bool cc_on_emails = 22; */
        if (message.ccOnEmails !== false)
            writer.tag(22, WireType.Varint).bool(message.ccOnEmails);
        /* string twilio_phone = 23; */
        if (message.twilioPhone !== "")
            writer.tag(23, WireType.LengthDelimited).string(message.twilioPhone);
        /* rd.company.Location.OutboundEmail outbound_email = 24; */
        if (message.outboundEmail)
            Location_OutboundEmail.internalBinaryWrite(message.outboundEmail, writer.tag(24, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID pricing_region_id = 25; */
        if (message.pricingRegionId)
            UUID.internalBinaryWrite(message.pricingRegionId, writer.tag(25, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.CashRounding cash_rounding = 26; */
        if (message.cashRounding)
            CashRounding.internalBinaryWrite(message.cashRounding, writer.tag(26, WireType.LengthDelimited).fork(), options).join();
        /* bool show_inventory = 27; */
        if (message.showInventory !== false)
            writer.tag(27, WireType.Varint).bool(message.showInventory);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.company.Location
 */
export const Location = new Location$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Location_OutboundEmail$Type extends MessageType<Location_OutboundEmail> {
    constructor() {
        super("rd.company.Location.OutboundEmail", [
            { no: 1, name: "custom_email_config_id", kind: "message", T: () => UUID },
            { no: 2, name: "username", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "domain", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Location_OutboundEmail>): Location_OutboundEmail {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.username = "";
        message.domain = "";
        if (value !== undefined)
            reflectionMergePartial<Location_OutboundEmail>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Location_OutboundEmail): Location_OutboundEmail {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID custom_email_config_id */ 1:
                    message.customEmailConfigId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customEmailConfigId);
                    break;
                case /* string username */ 2:
                    message.username = reader.string();
                    break;
                case /* string domain */ 3:
                    message.domain = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Location_OutboundEmail, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID custom_email_config_id = 1; */
        if (message.customEmailConfigId)
            UUID.internalBinaryWrite(message.customEmailConfigId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string username = 2; */
        if (message.username !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.username);
        /* string domain = 3; */
        if (message.domain !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.domain);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.company.Location.OutboundEmail
 */
export const Location_OutboundEmail = new Location_OutboundEmail$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Staff$Type extends MessageType<Staff> {
    constructor() {
        super("rd.company.Staff", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "company_id", kind: "message", T: () => UUID },
            { no: 5, name: "first_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "last_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "phone", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.sanitize.log": true } },
            { no: 10, name: "address", kind: "message", T: () => Address, options: { "rd.sanitize.log": true } },
            { no: 11, name: "stytch_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "role_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "stripe_issuing_cardholder_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "webauthn_pubkey_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "sms_consent", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 17, name: "email_consent", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 18, name: "is_attribution_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 19, name: "attribution_pin", kind: "scalar", T: 12 /*ScalarType.BYTES*/, options: { "rd.sanitize.api": true } }
        ]);
    }
    create(value?: PartialMessage<Staff>): Staff {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.firstName = "";
        message.lastName = "";
        message.phone = "";
        message.isActive = false;
        message.email = "";
        message.stytchUserId = "";
        message.code = "";
        message.roleIds = [];
        message.stripeIssuingCardholderId = "";
        message.webauthnPubkeyIds = [];
        message.smsConsent = false;
        message.emailConsent = false;
        message.isAttributionEnabled = false;
        message.attributionPin = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<Staff>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Staff): Staff {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 4:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* string first_name */ 5:
                    message.firstName = reader.string();
                    break;
                case /* string last_name */ 6:
                    message.lastName = reader.string();
                    break;
                case /* string phone */ 7:
                    message.phone = reader.string();
                    break;
                case /* bool is_active */ 8:
                    message.isActive = reader.bool();
                    break;
                case /* string email */ 9:
                    message.email = reader.string();
                    break;
                case /* rd.proto.address.Address address */ 10:
                    message.address = Address.internalBinaryRead(reader, reader.uint32(), options, message.address);
                    break;
                case /* string stytch_user_id */ 11:
                    message.stytchUserId = reader.string();
                    break;
                case /* string code */ 12:
                    message.code = reader.string();
                    break;
                case /* repeated string role_ids */ 13:
                    message.roleIds.push(reader.string());
                    break;
                case /* string stripe_issuing_cardholder_id */ 14:
                    message.stripeIssuingCardholderId = reader.string();
                    break;
                case /* repeated string webauthn_pubkey_ids */ 15:
                    message.webauthnPubkeyIds.push(reader.string());
                    break;
                case /* bool sms_consent */ 16:
                    message.smsConsent = reader.bool();
                    break;
                case /* bool email_consent */ 17:
                    message.emailConsent = reader.bool();
                    break;
                case /* bool is_attribution_enabled */ 18:
                    message.isAttributionEnabled = reader.bool();
                    break;
                case /* bytes attribution_pin */ 19:
                    message.attributionPin = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Staff, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 4; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string first_name = 5; */
        if (message.firstName !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.firstName);
        /* string last_name = 6; */
        if (message.lastName !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.lastName);
        /* string phone = 7; */
        if (message.phone !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.phone);
        /* bool is_active = 8; */
        if (message.isActive !== false)
            writer.tag(8, WireType.Varint).bool(message.isActive);
        /* string email = 9; */
        if (message.email !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.email);
        /* rd.proto.address.Address address = 10; */
        if (message.address)
            Address.internalBinaryWrite(message.address, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* string stytch_user_id = 11; */
        if (message.stytchUserId !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.stytchUserId);
        /* string code = 12; */
        if (message.code !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.code);
        /* repeated string role_ids = 13; */
        for (let i = 0; i < message.roleIds.length; i++)
            writer.tag(13, WireType.LengthDelimited).string(message.roleIds[i]);
        /* string stripe_issuing_cardholder_id = 14; */
        if (message.stripeIssuingCardholderId !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.stripeIssuingCardholderId);
        /* repeated string webauthn_pubkey_ids = 15; */
        for (let i = 0; i < message.webauthnPubkeyIds.length; i++)
            writer.tag(15, WireType.LengthDelimited).string(message.webauthnPubkeyIds[i]);
        /* bool sms_consent = 16; */
        if (message.smsConsent !== false)
            writer.tag(16, WireType.Varint).bool(message.smsConsent);
        /* bool email_consent = 17; */
        if (message.emailConsent !== false)
            writer.tag(17, WireType.Varint).bool(message.emailConsent);
        /* bool is_attribution_enabled = 18; */
        if (message.isAttributionEnabled !== false)
            writer.tag(18, WireType.Varint).bool(message.isAttributionEnabled);
        /* bytes attribution_pin = 19; */
        if (message.attributionPin.length)
            writer.tag(19, WireType.LengthDelimited).bytes(message.attributionPin);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.company.Staff
 */
export const Staff = new Staff$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PricingTiers$Type extends MessageType<PricingTiers> {
    constructor() {
        super("rd.company.PricingTiers", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "default_id_string", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "tiers_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => PricingTiers_Tier } }
        ]);
    }
    create(value?: PartialMessage<PricingTiers>): PricingTiers {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.defaultIdString = "";
        message.tiersById = {};
        if (value !== undefined)
            reflectionMergePartial<PricingTiers>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PricingTiers): PricingTiers {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* string default_id_string */ 4:
                    message.defaultIdString = reader.string();
                    break;
                case /* map<string, rd.company.PricingTiers.Tier> tiers_by_id */ 5:
                    this.binaryReadMap5(message.tiersById, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap5(map: PricingTiers["tiersById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof PricingTiers["tiersById"] | undefined, val: PricingTiers["tiersById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = PricingTiers_Tier.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.company.PricingTiers.tiers_by_id");
            }
        }
        map[key ?? ""] = val ?? PricingTiers_Tier.create();
    }
    internalBinaryWrite(message: PricingTiers, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string default_id_string = 4; */
        if (message.defaultIdString !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.defaultIdString);
        /* map<string, rd.company.PricingTiers.Tier> tiers_by_id = 5; */
        for (let k of globalThis.Object.keys(message.tiersById)) {
            writer.tag(5, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            PricingTiers_Tier.internalBinaryWrite(message.tiersById[k], writer, options);
            writer.join().join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.company.PricingTiers
 */
export const PricingTiers = new PricingTiers$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PricingTiers_Tier$Type extends MessageType<PricingTiers_Tier> {
    constructor() {
        super("rd.company.PricingTiers.Tier", [
            { no: 1, name: "id_string", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "rank", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "is_rule_based", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<PricingTiers_Tier>): PricingTiers_Tier {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.idString = "";
        message.name = "";
        message.rank = 0;
        message.isRuleBased = false;
        if (value !== undefined)
            reflectionMergePartial<PricingTiers_Tier>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PricingTiers_Tier): PricingTiers_Tier {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id_string */ 1:
                    message.idString = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* int32 rank */ 3:
                    message.rank = reader.int32();
                    break;
                case /* bool is_rule_based */ 4:
                    message.isRuleBased = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PricingTiers_Tier, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id_string = 1; */
        if (message.idString !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.idString);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* int32 rank = 3; */
        if (message.rank !== 0)
            writer.tag(3, WireType.Varint).int32(message.rank);
        /* bool is_rule_based = 4; */
        if (message.isRuleBased !== false)
            writer.tag(4, WireType.Varint).bool(message.isRuleBased);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.company.PricingTiers.Tier
 */
export const PricingTiers_Tier = new PricingTiers_Tier$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PricingTiersLog$Type extends MessageType<PricingTiersLog> {
    constructor() {
        super("rd.company.PricingTiersLog", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "pricing_tiers", kind: "message", T: () => PricingTiers }
        ]);
    }
    create(value?: PartialMessage<PricingTiersLog>): PricingTiersLog {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<PricingTiersLog>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PricingTiersLog): PricingTiersLog {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* rd.company.PricingTiers pricing_tiers */ 3:
                    message.pricingTiers = PricingTiers.internalBinaryRead(reader, reader.uint32(), options, message.pricingTiers);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PricingTiersLog, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.PricingTiers pricing_tiers = 3; */
        if (message.pricingTiers)
            PricingTiers.internalBinaryWrite(message.pricingTiers, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.company.PricingTiersLog
 */
export const PricingTiersLog = new PricingTiersLog$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FinancingTerms$Type extends MessageType<FinancingTerms> {
    constructor() {
        super("rd.company.FinancingTerms", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "default_id_string", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "terms_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => FinancingTerms_Term } }
        ]);
    }
    create(value?: PartialMessage<FinancingTerms>): FinancingTerms {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.defaultIdString = "";
        message.termsById = {};
        if (value !== undefined)
            reflectionMergePartial<FinancingTerms>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FinancingTerms): FinancingTerms {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* string default_id_string */ 4:
                    message.defaultIdString = reader.string();
                    break;
                case /* map<string, rd.company.FinancingTerms.Term> terms_by_id */ 5:
                    this.binaryReadMap5(message.termsById, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap5(map: FinancingTerms["termsById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof FinancingTerms["termsById"] | undefined, val: FinancingTerms["termsById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = FinancingTerms_Term.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.company.FinancingTerms.terms_by_id");
            }
        }
        map[key ?? ""] = val ?? FinancingTerms_Term.create();
    }
    internalBinaryWrite(message: FinancingTerms, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string default_id_string = 4; */
        if (message.defaultIdString !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.defaultIdString);
        /* map<string, rd.company.FinancingTerms.Term> terms_by_id = 5; */
        for (let k of globalThis.Object.keys(message.termsById)) {
            writer.tag(5, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            FinancingTerms_Term.internalBinaryWrite(message.termsById[k], writer, options);
            writer.join().join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.company.FinancingTerms
 */
export const FinancingTerms = new FinancingTerms$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FinancingTerms_Term$Type extends MessageType<FinancingTerms_Term> {
    constructor() {
        super("rd.company.FinancingTerms.Term", [
            { no: 1, name: "id_string", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "reference_date", kind: "enum", T: () => ["rd.company.FinancingTerms.Term.ReferenceDate", FinancingTerms_Term_ReferenceDate, "REFERENCE_DATE_"] },
            { no: 3, name: "due_days", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "discount_days", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "discount_rate", kind: "message", T: () => Decimal },
            { no: 6, name: "position", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "is_early_payment_discount_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<FinancingTerms_Term>): FinancingTerms_Term {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.idString = "";
        message.referenceDate = 0;
        message.dueDays = 0;
        message.discountDays = 0;
        message.position = 0;
        message.isEarlyPaymentDiscountEnabled = false;
        message.name = "";
        if (value !== undefined)
            reflectionMergePartial<FinancingTerms_Term>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FinancingTerms_Term): FinancingTerms_Term {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id_string */ 1:
                    message.idString = reader.string();
                    break;
                case /* rd.company.FinancingTerms.Term.ReferenceDate reference_date */ 2:
                    message.referenceDate = reader.int32();
                    break;
                case /* int32 due_days */ 3:
                    message.dueDays = reader.int32();
                    break;
                case /* int32 discount_days */ 4:
                    message.discountDays = reader.int32();
                    break;
                case /* rd.proto.decimal.Decimal discount_rate */ 5:
                    message.discountRate = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.discountRate);
                    break;
                case /* int32 position */ 6:
                    message.position = reader.int32();
                    break;
                case /* bool is_early_payment_discount_enabled */ 7:
                    message.isEarlyPaymentDiscountEnabled = reader.bool();
                    break;
                case /* string name */ 8:
                    message.name = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FinancingTerms_Term, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id_string = 1; */
        if (message.idString !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.idString);
        /* rd.company.FinancingTerms.Term.ReferenceDate reference_date = 2; */
        if (message.referenceDate !== 0)
            writer.tag(2, WireType.Varint).int32(message.referenceDate);
        /* int32 due_days = 3; */
        if (message.dueDays !== 0)
            writer.tag(3, WireType.Varint).int32(message.dueDays);
        /* int32 discount_days = 4; */
        if (message.discountDays !== 0)
            writer.tag(4, WireType.Varint).int32(message.discountDays);
        /* rd.proto.decimal.Decimal discount_rate = 5; */
        if (message.discountRate)
            Decimal.internalBinaryWrite(message.discountRate, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* int32 position = 6; */
        if (message.position !== 0)
            writer.tag(6, WireType.Varint).int32(message.position);
        /* bool is_early_payment_discount_enabled = 7; */
        if (message.isEarlyPaymentDiscountEnabled !== false)
            writer.tag(7, WireType.Varint).bool(message.isEarlyPaymentDiscountEnabled);
        /* string name = 8; */
        if (message.name !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.name);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.company.FinancingTerms.Term
 */
export const FinancingTerms_Term = new FinancingTerms_Term$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FinancingTermsLog$Type extends MessageType<FinancingTermsLog> {
    constructor() {
        super("rd.company.FinancingTermsLog", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "financing_terms", kind: "message", T: () => FinancingTerms }
        ]);
    }
    create(value?: PartialMessage<FinancingTermsLog>): FinancingTermsLog {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<FinancingTermsLog>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FinancingTermsLog): FinancingTermsLog {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* rd.company.FinancingTerms financing_terms */ 3:
                    message.financingTerms = FinancingTerms.internalBinaryRead(reader, reader.uint32(), options, message.financingTerms);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FinancingTermsLog, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.FinancingTerms financing_terms = 3; */
        if (message.financingTerms)
            FinancingTerms.internalBinaryWrite(message.financingTerms, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.company.FinancingTermsLog
 */
export const FinancingTermsLog = new FinancingTermsLog$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AdditionalFees$Type extends MessageType<AdditionalFees> {
    constructor() {
        super("rd.company.AdditionalFees", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "fees_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => AdditionalFees_Fee } }
        ]);
    }
    create(value?: PartialMessage<AdditionalFees>): AdditionalFees {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.feesById = {};
        if (value !== undefined)
            reflectionMergePartial<AdditionalFees>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AdditionalFees): AdditionalFees {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* map<string, rd.company.AdditionalFees.Fee> fees_by_id */ 4:
                    this.binaryReadMap4(message.feesById, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap4(map: AdditionalFees["feesById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof AdditionalFees["feesById"] | undefined, val: AdditionalFees["feesById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = AdditionalFees_Fee.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.company.AdditionalFees.fees_by_id");
            }
        }
        map[key ?? ""] = val ?? AdditionalFees_Fee.create();
    }
    internalBinaryWrite(message: AdditionalFees, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.company.AdditionalFees.Fee> fees_by_id = 4; */
        for (let k of globalThis.Object.keys(message.feesById)) {
            writer.tag(4, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            AdditionalFees_Fee.internalBinaryWrite(message.feesById[k], writer, options);
            writer.join().join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.company.AdditionalFees
 */
export const AdditionalFees = new AdditionalFees$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AdditionalFees_LocationFeeOverride$Type extends MessageType<AdditionalFees_LocationFeeOverride> {
    constructor() {
        super("rd.company.AdditionalFees.LocationFeeOverride", [
            { no: 1, name: "fee", kind: "message", T: () => Money },
            { no: 2, name: "fee_rate", kind: "message", T: () => Decimal }
        ]);
    }
    create(value?: PartialMessage<AdditionalFees_LocationFeeOverride>): AdditionalFees_LocationFeeOverride {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AdditionalFees_LocationFeeOverride>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AdditionalFees_LocationFeeOverride): AdditionalFees_LocationFeeOverride {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.money.Money fee */ 1:
                    message.fee = Money.internalBinaryRead(reader, reader.uint32(), options, message.fee);
                    break;
                case /* rd.proto.decimal.Decimal fee_rate */ 2:
                    message.feeRate = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.feeRate);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AdditionalFees_LocationFeeOverride, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.money.Money fee = 1; */
        if (message.fee)
            Money.internalBinaryWrite(message.fee, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal fee_rate = 2; */
        if (message.feeRate)
            Decimal.internalBinaryWrite(message.feeRate, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.company.AdditionalFees.LocationFeeOverride
 */
export const AdditionalFees_LocationFeeOverride = new AdditionalFees_LocationFeeOverride$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AdditionalFees_Fee$Type extends MessageType<AdditionalFees_Fee> {
    constructor() {
        super("rd.company.AdditionalFees.Fee", [
            { no: 1, name: "id_string", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "fee", kind: "message", T: () => Money },
            { no: 4, name: "fee_rate", kind: "message", T: () => Decimal },
            { no: 5, name: "is_taxable", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "position", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "apply_to_sales", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "apply_to_orders", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "apply_to_transfers", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "apply_to_location_ids", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 8 /*ScalarType.BOOL*/ } },
            { no: 11, name: "fee_override_by_location_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => AdditionalFees_LocationFeeOverride } },
            { no: 12, name: "type", kind: "enum", T: () => ["rd.company.AdditionalFees.Fee.Type", AdditionalFees_Fee_Type, "TYPE_"] },
            { no: 13, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 14, name: "override_type", kind: "enum", T: () => ["rd.company.AdditionalFees.Fee.OverrideType", AdditionalFees_Fee_OverrideType, "OVERRIDE_TYPE_"] },
            { no: 15, name: "apply_to_states", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 8 /*ScalarType.BOOL*/ } },
            { no: 16, name: "fee_override_by_state", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => AdditionalFees_LocationFeeOverride } }
        ]);
    }
    create(value?: PartialMessage<AdditionalFees_Fee>): AdditionalFees_Fee {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.idString = "";
        message.name = "";
        message.isTaxable = false;
        message.position = 0;
        message.applyToSales = false;
        message.applyToOrders = false;
        message.applyToTransfers = false;
        message.applyToLocationIds = {};
        message.feeOverrideByLocationId = {};
        message.type = 0;
        message.isActive = false;
        message.overrideType = 0;
        message.applyToStates = {};
        message.feeOverrideByState = {};
        if (value !== undefined)
            reflectionMergePartial<AdditionalFees_Fee>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AdditionalFees_Fee): AdditionalFees_Fee {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id_string */ 1:
                    message.idString = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* rd.proto.money.Money fee */ 3:
                    message.fee = Money.internalBinaryRead(reader, reader.uint32(), options, message.fee);
                    break;
                case /* rd.proto.decimal.Decimal fee_rate */ 4:
                    message.feeRate = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.feeRate);
                    break;
                case /* bool is_taxable */ 5:
                    message.isTaxable = reader.bool();
                    break;
                case /* int32 position */ 6:
                    message.position = reader.int32();
                    break;
                case /* bool apply_to_sales */ 7:
                    message.applyToSales = reader.bool();
                    break;
                case /* bool apply_to_orders */ 8:
                    message.applyToOrders = reader.bool();
                    break;
                case /* bool apply_to_transfers */ 9:
                    message.applyToTransfers = reader.bool();
                    break;
                case /* map<string, bool> apply_to_location_ids */ 10:
                    this.binaryReadMap10(message.applyToLocationIds, reader, options);
                    break;
                case /* map<string, rd.company.AdditionalFees.LocationFeeOverride> fee_override_by_location_id */ 11:
                    this.binaryReadMap11(message.feeOverrideByLocationId, reader, options);
                    break;
                case /* rd.company.AdditionalFees.Fee.Type type */ 12:
                    message.type = reader.int32();
                    break;
                case /* bool is_active */ 13:
                    message.isActive = reader.bool();
                    break;
                case /* rd.company.AdditionalFees.Fee.OverrideType override_type */ 14:
                    message.overrideType = reader.int32();
                    break;
                case /* map<string, bool> apply_to_states */ 15:
                    this.binaryReadMap15(message.applyToStates, reader, options);
                    break;
                case /* map<string, rd.company.AdditionalFees.LocationFeeOverride> fee_override_by_state */ 16:
                    this.binaryReadMap16(message.feeOverrideByState, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap10(map: AdditionalFees_Fee["applyToLocationIds"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof AdditionalFees_Fee["applyToLocationIds"] | undefined, val: AdditionalFees_Fee["applyToLocationIds"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.bool();
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.company.AdditionalFees.Fee.apply_to_location_ids");
            }
        }
        map[key ?? ""] = val ?? false;
    }
    private binaryReadMap11(map: AdditionalFees_Fee["feeOverrideByLocationId"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof AdditionalFees_Fee["feeOverrideByLocationId"] | undefined, val: AdditionalFees_Fee["feeOverrideByLocationId"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = AdditionalFees_LocationFeeOverride.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.company.AdditionalFees.Fee.fee_override_by_location_id");
            }
        }
        map[key ?? ""] = val ?? AdditionalFees_LocationFeeOverride.create();
    }
    private binaryReadMap15(map: AdditionalFees_Fee["applyToStates"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof AdditionalFees_Fee["applyToStates"] | undefined, val: AdditionalFees_Fee["applyToStates"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.bool();
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.company.AdditionalFees.Fee.apply_to_states");
            }
        }
        map[key ?? ""] = val ?? false;
    }
    private binaryReadMap16(map: AdditionalFees_Fee["feeOverrideByState"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof AdditionalFees_Fee["feeOverrideByState"] | undefined, val: AdditionalFees_Fee["feeOverrideByState"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = AdditionalFees_LocationFeeOverride.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.company.AdditionalFees.Fee.fee_override_by_state");
            }
        }
        map[key ?? ""] = val ?? AdditionalFees_LocationFeeOverride.create();
    }
    internalBinaryWrite(message: AdditionalFees_Fee, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id_string = 1; */
        if (message.idString !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.idString);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* rd.proto.money.Money fee = 3; */
        if (message.fee)
            Money.internalBinaryWrite(message.fee, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal fee_rate = 4; */
        if (message.feeRate)
            Decimal.internalBinaryWrite(message.feeRate, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* bool is_taxable = 5; */
        if (message.isTaxable !== false)
            writer.tag(5, WireType.Varint).bool(message.isTaxable);
        /* int32 position = 6; */
        if (message.position !== 0)
            writer.tag(6, WireType.Varint).int32(message.position);
        /* bool apply_to_sales = 7; */
        if (message.applyToSales !== false)
            writer.tag(7, WireType.Varint).bool(message.applyToSales);
        /* bool apply_to_orders = 8; */
        if (message.applyToOrders !== false)
            writer.tag(8, WireType.Varint).bool(message.applyToOrders);
        /* bool apply_to_transfers = 9; */
        if (message.applyToTransfers !== false)
            writer.tag(9, WireType.Varint).bool(message.applyToTransfers);
        /* map<string, bool> apply_to_location_ids = 10; */
        for (let k of globalThis.Object.keys(message.applyToLocationIds))
            writer.tag(10, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.Varint).bool(message.applyToLocationIds[k]).join();
        /* map<string, rd.company.AdditionalFees.LocationFeeOverride> fee_override_by_location_id = 11; */
        for (let k of globalThis.Object.keys(message.feeOverrideByLocationId)) {
            writer.tag(11, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            AdditionalFees_LocationFeeOverride.internalBinaryWrite(message.feeOverrideByLocationId[k], writer, options);
            writer.join().join();
        }
        /* rd.company.AdditionalFees.Fee.Type type = 12; */
        if (message.type !== 0)
            writer.tag(12, WireType.Varint).int32(message.type);
        /* bool is_active = 13; */
        if (message.isActive !== false)
            writer.tag(13, WireType.Varint).bool(message.isActive);
        /* rd.company.AdditionalFees.Fee.OverrideType override_type = 14; */
        if (message.overrideType !== 0)
            writer.tag(14, WireType.Varint).int32(message.overrideType);
        /* map<string, bool> apply_to_states = 15; */
        for (let k of globalThis.Object.keys(message.applyToStates))
            writer.tag(15, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.Varint).bool(message.applyToStates[k]).join();
        /* map<string, rd.company.AdditionalFees.LocationFeeOverride> fee_override_by_state = 16; */
        for (let k of globalThis.Object.keys(message.feeOverrideByState)) {
            writer.tag(16, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            AdditionalFees_LocationFeeOverride.internalBinaryWrite(message.feeOverrideByState[k], writer, options);
            writer.join().join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.company.AdditionalFees.Fee
 */
export const AdditionalFees_Fee = new AdditionalFees_Fee$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AdditionalFeesLog$Type extends MessageType<AdditionalFeesLog> {
    constructor() {
        super("rd.company.AdditionalFeesLog", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "additional_fees", kind: "message", T: () => AdditionalFees }
        ]);
    }
    create(value?: PartialMessage<AdditionalFeesLog>): AdditionalFeesLog {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AdditionalFeesLog>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AdditionalFeesLog): AdditionalFeesLog {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* rd.company.AdditionalFees additional_fees */ 3:
                    message.additionalFees = AdditionalFees.internalBinaryRead(reader, reader.uint32(), options, message.additionalFees);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AdditionalFeesLog, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.AdditionalFees additional_fees = 3; */
        if (message.additionalFees)
            AdditionalFees.internalBinaryWrite(message.additionalFees, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.company.AdditionalFeesLog
 */
export const AdditionalFeesLog = new AdditionalFeesLog$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProductCategory$Type extends MessageType<ProductCategory> {
    constructor() {
        super("rd.company.ProductCategory", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "company_id", kind: "message", T: () => UUID },
            { no: 5, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "type", kind: "enum", T: () => ["rd.company.ProductCategory.Type", ProductCategory_Type, "TYPE_"] },
            { no: 7, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "icon_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ProductCategory>): ProductCategory {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.type = 0;
        message.isActive = false;
        message.iconName = "";
        if (value !== undefined)
            reflectionMergePartial<ProductCategory>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ProductCategory): ProductCategory {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 4:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* string name */ 5:
                    message.name = reader.string();
                    break;
                case /* rd.company.ProductCategory.Type type */ 6:
                    message.type = reader.int32();
                    break;
                case /* bool is_active */ 7:
                    message.isActive = reader.bool();
                    break;
                case /* string icon_name */ 8:
                    message.iconName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ProductCategory, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 4; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string name = 5; */
        if (message.name !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.name);
        /* rd.company.ProductCategory.Type type = 6; */
        if (message.type !== 0)
            writer.tag(6, WireType.Varint).int32(message.type);
        /* bool is_active = 7; */
        if (message.isActive !== false)
            writer.tag(7, WireType.Varint).bool(message.isActive);
        /* string icon_name = 8; */
        if (message.iconName !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.iconName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.company.ProductCategory
 */
export const ProductCategory = new ProductCategory$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Roles$Type extends MessageType<Roles> {
    constructor() {
        super("rd.company.Roles", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "roles_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Roles_Role } }
        ]);
    }
    create(value?: PartialMessage<Roles>): Roles {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.rolesById = {};
        if (value !== undefined)
            reflectionMergePartial<Roles>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Roles): Roles {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* map<string, rd.company.Roles.Role> roles_by_id */ 2:
                    this.binaryReadMap2(message.rolesById, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap2(map: Roles["rolesById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof Roles["rolesById"] | undefined, val: Roles["rolesById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Roles_Role.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.company.Roles.roles_by_id");
            }
        }
        map[key ?? ""] = val ?? Roles_Role.create();
    }
    internalBinaryWrite(message: Roles, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.company.Roles.Role> roles_by_id = 2; */
        for (let k of globalThis.Object.keys(message.rolesById)) {
            writer.tag(2, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Roles_Role.internalBinaryWrite(message.rolesById[k], writer, options);
            writer.join().join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.company.Roles
 */
export const Roles = new Roles$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Roles_Role$Type extends MessageType<Roles_Role> {
    constructor() {
        super("rd.company.Roles.Role", [
            { no: 1, name: "id_string", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "permissions", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 8 /*ScalarType.BOOL*/ } },
            { no: 4, name: "linked_roles", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "category", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "position", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<Roles_Role>): Roles_Role {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.idString = "";
        message.name = "";
        message.permissions = {};
        message.linkedRoles = [];
        message.category = "";
        message.description = "";
        message.position = 0;
        if (value !== undefined)
            reflectionMergePartial<Roles_Role>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Roles_Role): Roles_Role {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id_string */ 1:
                    message.idString = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* map<string, bool> permissions */ 3:
                    this.binaryReadMap3(message.permissions, reader, options);
                    break;
                case /* repeated string linked_roles */ 4:
                    message.linkedRoles.push(reader.string());
                    break;
                case /* string category */ 5:
                    message.category = reader.string();
                    break;
                case /* string description */ 6:
                    message.description = reader.string();
                    break;
                case /* int32 position */ 7:
                    message.position = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap3(map: Roles_Role["permissions"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof Roles_Role["permissions"] | undefined, val: Roles_Role["permissions"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.bool();
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.company.Roles.Role.permissions");
            }
        }
        map[key ?? ""] = val ?? false;
    }
    internalBinaryWrite(message: Roles_Role, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id_string = 1; */
        if (message.idString !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.idString);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* map<string, bool> permissions = 3; */
        for (let k of globalThis.Object.keys(message.permissions))
            writer.tag(3, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.Varint).bool(message.permissions[k]).join();
        /* repeated string linked_roles = 4; */
        for (let i = 0; i < message.linkedRoles.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.linkedRoles[i]);
        /* string category = 5; */
        if (message.category !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.category);
        /* string description = 6; */
        if (message.description !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.description);
        /* int32 position = 7; */
        if (message.position !== 0)
            writer.tag(7, WireType.Varint).int32(message.position);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.company.Roles.Role
 */
export const Roles_Role = new Roles_Role$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DooerStaff$Type extends MessageType<DooerStaff> {
    constructor() {
        super("rd.company.DooerStaff", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "phone", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "stytch_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "code", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<DooerStaff>): DooerStaff {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.phone = "";
        message.email = "";
        message.stytchUserId = "";
        message.code = "";
        if (value !== undefined)
            reflectionMergePartial<DooerStaff>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DooerStaff): DooerStaff {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* string phone */ 5:
                    message.phone = reader.string();
                    break;
                case /* string email */ 6:
                    message.email = reader.string();
                    break;
                case /* string stytch_user_id */ 7:
                    message.stytchUserId = reader.string();
                    break;
                case /* string code */ 8:
                    message.code = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DooerStaff, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string phone = 5; */
        if (message.phone !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.phone);
        /* string email = 6; */
        if (message.email !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.email);
        /* string stytch_user_id = 7; */
        if (message.stytchUserId !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.stytchUserId);
        /* string code = 8; */
        if (message.code !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.code);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.company.DooerStaff
 */
export const DooerStaff = new DooerStaff$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CashRegister$Type extends MessageType<CashRegister> {
    constructor() {
        super("rd.company.CashRegister", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "balance", kind: "message", T: () => Money },
            { no: 5, name: "float", kind: "message", T: () => Money },
            { no: 6, name: "company_id", kind: "message", T: () => UUID },
            { no: 7, name: "location_id", kind: "message", T: () => UUID },
            { no: 8, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<CashRegister>): CashRegister {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.isActive = false;
        if (value !== undefined)
            reflectionMergePartial<CashRegister>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CashRegister): CashRegister {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* rd.proto.money.Money balance */ 4:
                    message.balance = Money.internalBinaryRead(reader, reader.uint32(), options, message.balance);
                    break;
                case /* rd.proto.money.Money float */ 5:
                    message.float = Money.internalBinaryRead(reader, reader.uint32(), options, message.float);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 6:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* rd.proto.uuid.UUID location_id */ 7:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                case /* string name */ 8:
                    message.name = reader.string();
                    break;
                case /* bool is_active */ 9:
                    message.isActive = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CashRegister, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money balance = 4; */
        if (message.balance)
            Money.internalBinaryWrite(message.balance, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money float = 5; */
        if (message.float)
            Money.internalBinaryWrite(message.float, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 6; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID location_id = 7; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* string name = 8; */
        if (message.name !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.name);
        /* bool is_active = 9; */
        if (message.isActive !== false)
            writer.tag(9, WireType.Varint).bool(message.isActive);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.company.CashRegister
 */
export const CashRegister = new CashRegister$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CxaUser$Type extends MessageType<CxaUser> {
    constructor() {
        super("rd.company.CxaUser", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "phone", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "stytch_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CxaUser>): CxaUser {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.phone = "";
        message.stytchUserId = "";
        if (value !== undefined)
            reflectionMergePartial<CxaUser>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CxaUser): CxaUser {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* string phone */ 3:
                    message.phone = reader.string();
                    break;
                case /* string stytch_user_id */ 4:
                    message.stytchUserId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CxaUser, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string phone = 3; */
        if (message.phone !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.phone);
        /* string stytch_user_id = 4; */
        if (message.stytchUserId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.stytchUserId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.company.CxaUser
 */
export const CxaUser = new CxaUser$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaxRate$Type extends MessageType<TaxRate> {
    constructor() {
        super("rd.company.TaxRate", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "company_id", kind: "message", T: () => UUID },
            { no: 5, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "rate", kind: "message", T: () => Decimal },
            { no: 7, name: "position", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "type", kind: "enum", T: () => ["rd.company.TaxRate.Type", TaxRate_Type, "TYPE_"] },
            { no: 10, name: "location_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<TaxRate>): TaxRate {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.position = 0;
        message.isActive = false;
        message.type = 0;
        message.locationIds = [];
        if (value !== undefined)
            reflectionMergePartial<TaxRate>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaxRate): TaxRate {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 4:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* string name */ 5:
                    message.name = reader.string();
                    break;
                case /* rd.proto.decimal.Decimal rate */ 6:
                    message.rate = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.rate);
                    break;
                case /* int32 position */ 7:
                    message.position = reader.int32();
                    break;
                case /* bool is_active */ 8:
                    message.isActive = reader.bool();
                    break;
                case /* rd.company.TaxRate.Type type */ 9:
                    message.type = reader.int32();
                    break;
                case /* repeated rd.proto.uuid.UUID location_ids */ 10:
                    message.locationIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaxRate, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 4; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string name = 5; */
        if (message.name !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.name);
        /* rd.proto.decimal.Decimal rate = 6; */
        if (message.rate)
            Decimal.internalBinaryWrite(message.rate, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* int32 position = 7; */
        if (message.position !== 0)
            writer.tag(7, WireType.Varint).int32(message.position);
        /* bool is_active = 8; */
        if (message.isActive !== false)
            writer.tag(8, WireType.Varint).bool(message.isActive);
        /* rd.company.TaxRate.Type type = 9; */
        if (message.type !== 0)
            writer.tag(9, WireType.Varint).int32(message.type);
        /* repeated rd.proto.uuid.UUID location_ids = 10; */
        for (let i = 0; i < message.locationIds.length; i++)
            UUID.internalBinaryWrite(message.locationIds[i], writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.company.TaxRate
 */
export const TaxRate = new TaxRate$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaxRateLog$Type extends MessageType<TaxRateLog> {
    constructor() {
        super("rd.company.TaxRateLog", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "tax_rate", kind: "message", T: () => TaxRate }
        ]);
    }
    create(value?: PartialMessage<TaxRateLog>): TaxRateLog {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<TaxRateLog>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaxRateLog): TaxRateLog {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* rd.company.TaxRate tax_rate */ 3:
                    message.taxRate = TaxRate.internalBinaryRead(reader, reader.uint32(), options, message.taxRate);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaxRateLog, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.TaxRate tax_rate = 3; */
        if (message.taxRate)
            TaxRate.internalBinaryWrite(message.taxRate, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.company.TaxRateLog
 */
export const TaxRateLog = new TaxRateLog$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Entity$Type extends MessageType<Entity> {
    constructor() {
        super("rd.company.Entity", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "company_id", kind: "message", T: () => UUID },
            { no: 3, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "stripe_express_account_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "stripe_custom_account_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "stripe_financial_account_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "stripe_bank_payment_method_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "country", kind: "enum", T: () => ["rd.proto.address.Address.Country", Address_Country, "COUNTRY_"] },
            { no: 11, name: "stripe_customer_account_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "billings", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Entity_Billing }
        ]);
    }
    create(value?: PartialMessage<Entity>): Entity {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.stripeExpressAccountId = "";
        message.stripeCustomAccountId = "";
        message.stripeFinancialAccountId = "";
        message.stripeBankPaymentMethodId = "";
        message.name = "";
        message.country = 0;
        message.stripeCustomerAccountId = "";
        message.billings = [];
        if (value !== undefined)
            reflectionMergePartial<Entity>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Entity): Entity {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 2:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* google.protobuf.Timestamp created_at */ 3:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 4:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* string stripe_express_account_id */ 5:
                    message.stripeExpressAccountId = reader.string();
                    break;
                case /* string stripe_custom_account_id */ 6:
                    message.stripeCustomAccountId = reader.string();
                    break;
                case /* string stripe_financial_account_id */ 7:
                    message.stripeFinancialAccountId = reader.string();
                    break;
                case /* string stripe_bank_payment_method_id */ 8:
                    message.stripeBankPaymentMethodId = reader.string();
                    break;
                case /* string name */ 9:
                    message.name = reader.string();
                    break;
                case /* rd.proto.address.Address.Country country */ 10:
                    message.country = reader.int32();
                    break;
                case /* string stripe_customer_account_id */ 11:
                    message.stripeCustomerAccountId = reader.string();
                    break;
                case /* repeated rd.company.Entity.Billing billings */ 12:
                    message.billings.push(Entity_Billing.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Entity, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 2; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 3; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 4; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string stripe_express_account_id = 5; */
        if (message.stripeExpressAccountId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.stripeExpressAccountId);
        /* string stripe_custom_account_id = 6; */
        if (message.stripeCustomAccountId !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.stripeCustomAccountId);
        /* string stripe_financial_account_id = 7; */
        if (message.stripeFinancialAccountId !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.stripeFinancialAccountId);
        /* string stripe_bank_payment_method_id = 8; */
        if (message.stripeBankPaymentMethodId !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.stripeBankPaymentMethodId);
        /* string name = 9; */
        if (message.name !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.name);
        /* rd.proto.address.Address.Country country = 10; */
        if (message.country !== 0)
            writer.tag(10, WireType.Varint).int32(message.country);
        /* string stripe_customer_account_id = 11; */
        if (message.stripeCustomerAccountId !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.stripeCustomerAccountId);
        /* repeated rd.company.Entity.Billing billings = 12; */
        for (let i = 0; i < message.billings.length; i++)
            Entity_Billing.internalBinaryWrite(message.billings[i], writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.company.Entity
 */
export const Entity = new Entity$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Entity_Billing$Type extends MessageType<Entity_Billing> {
    constructor() {
        super("rd.company.Entity.Billing", [
            { no: 1, name: "type", kind: "enum", T: () => ["rd.company.Entity.Billing.Type", Entity_Billing_Type, "TYPE_"] },
            { no: 2, name: "stripe_subscription_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "next_billing_date", kind: "message", T: () => Timestamp },
            { no: 4, name: "stripe_subscription_schedule_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Entity_Billing>): Entity_Billing {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.type = 0;
        message.stripeSubscriptionId = "";
        message.stripeSubscriptionScheduleId = "";
        if (value !== undefined)
            reflectionMergePartial<Entity_Billing>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Entity_Billing): Entity_Billing {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.company.Entity.Billing.Type type */ 1:
                    message.type = reader.int32();
                    break;
                case /* string stripe_subscription_id */ 2:
                    message.stripeSubscriptionId = reader.string();
                    break;
                case /* google.protobuf.Timestamp next_billing_date */ 3:
                    message.nextBillingDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.nextBillingDate);
                    break;
                case /* string stripe_subscription_schedule_id */ 4:
                    message.stripeSubscriptionScheduleId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Entity_Billing, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.company.Entity.Billing.Type type = 1; */
        if (message.type !== 0)
            writer.tag(1, WireType.Varint).int32(message.type);
        /* string stripe_subscription_id = 2; */
        if (message.stripeSubscriptionId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.stripeSubscriptionId);
        /* google.protobuf.Timestamp next_billing_date = 3; */
        if (message.nextBillingDate)
            Timestamp.internalBinaryWrite(message.nextBillingDate, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string stripe_subscription_schedule_id = 4; */
        if (message.stripeSubscriptionScheduleId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.stripeSubscriptionScheduleId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.company.Entity.Billing
 */
export const Entity_Billing = new Entity_Billing$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EntityLog$Type extends MessageType<EntityLog> {
    constructor() {
        super("rd.company.EntityLog", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "entity", kind: "message", T: () => Entity }
        ]);
    }
    create(value?: PartialMessage<EntityLog>): EntityLog {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<EntityLog>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EntityLog): EntityLog {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* rd.company.Entity entity */ 3:
                    message.entity = Entity.internalBinaryRead(reader, reader.uint32(), options, message.entity);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EntityLog, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.Entity entity = 3; */
        if (message.entity)
            Entity.internalBinaryWrite(message.entity, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.company.EntityLog
 */
export const EntityLog = new EntityLog$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FinanceChargeSetting$Type extends MessageType<FinanceChargeSetting> {
    constructor() {
        super("rd.company.FinanceChargeSetting", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "company_id", kind: "message", T: () => UUID },
            { no: 3, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "percentage_fee", kind: "message", T: () => Decimal },
            { no: 6, name: "min_assessment_balance", kind: "message", T: () => Money },
            { no: 7, name: "min_charge_fee", kind: "message", T: () => Money },
            { no: 8, name: "grace_period_days", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "is_compounded", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "position", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 12, name: "is_default", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 13, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<FinanceChargeSetting>): FinanceChargeSetting {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.gracePeriodDays = 0;
        message.isCompounded = false;
        message.position = 0;
        message.isActive = false;
        message.isDefault = false;
        message.name = "";
        if (value !== undefined)
            reflectionMergePartial<FinanceChargeSetting>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FinanceChargeSetting): FinanceChargeSetting {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 2:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* google.protobuf.Timestamp created_at */ 3:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 4:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* rd.proto.decimal.Decimal percentage_fee */ 5:
                    message.percentageFee = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.percentageFee);
                    break;
                case /* rd.proto.money.Money min_assessment_balance */ 6:
                    message.minAssessmentBalance = Money.internalBinaryRead(reader, reader.uint32(), options, message.minAssessmentBalance);
                    break;
                case /* rd.proto.money.Money min_charge_fee */ 7:
                    message.minChargeFee = Money.internalBinaryRead(reader, reader.uint32(), options, message.minChargeFee);
                    break;
                case /* int32 grace_period_days */ 8:
                    message.gracePeriodDays = reader.int32();
                    break;
                case /* bool is_compounded */ 9:
                    message.isCompounded = reader.bool();
                    break;
                case /* int32 position */ 10:
                    message.position = reader.int32();
                    break;
                case /* bool is_active */ 11:
                    message.isActive = reader.bool();
                    break;
                case /* bool is_default */ 12:
                    message.isDefault = reader.bool();
                    break;
                case /* string name */ 13:
                    message.name = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FinanceChargeSetting, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 2; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 3; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 4; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal percentage_fee = 5; */
        if (message.percentageFee)
            Decimal.internalBinaryWrite(message.percentageFee, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money min_assessment_balance = 6; */
        if (message.minAssessmentBalance)
            Money.internalBinaryWrite(message.minAssessmentBalance, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money min_charge_fee = 7; */
        if (message.minChargeFee)
            Money.internalBinaryWrite(message.minChargeFee, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* int32 grace_period_days = 8; */
        if (message.gracePeriodDays !== 0)
            writer.tag(8, WireType.Varint).int32(message.gracePeriodDays);
        /* bool is_compounded = 9; */
        if (message.isCompounded !== false)
            writer.tag(9, WireType.Varint).bool(message.isCompounded);
        /* int32 position = 10; */
        if (message.position !== 0)
            writer.tag(10, WireType.Varint).int32(message.position);
        /* bool is_active = 11; */
        if (message.isActive !== false)
            writer.tag(11, WireType.Varint).bool(message.isActive);
        /* bool is_default = 12; */
        if (message.isDefault !== false)
            writer.tag(12, WireType.Varint).bool(message.isDefault);
        /* string name = 13; */
        if (message.name !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.name);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.company.FinanceChargeSetting
 */
export const FinanceChargeSetting = new FinanceChargeSetting$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SaleForm$Type extends MessageType<SaleForm> {
    constructor() {
        super("rd.company.SaleForm", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "company_id", kind: "message", T: () => UUID },
            { no: 3, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "custom_fields", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SaleForm_CustomField }
        ]);
    }
    create(value?: PartialMessage<SaleForm>): SaleForm {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.customFields = [];
        if (value !== undefined)
            reflectionMergePartial<SaleForm>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SaleForm): SaleForm {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 2:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* google.protobuf.Timestamp created_at */ 3:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 4:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* string name */ 5:
                    message.name = reader.string();
                    break;
                case /* repeated rd.company.SaleForm.CustomField custom_fields */ 6:
                    message.customFields.push(SaleForm_CustomField.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SaleForm, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 2; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 3; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 4; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string name = 5; */
        if (message.name !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.name);
        /* repeated rd.company.SaleForm.CustomField custom_fields = 6; */
        for (let i = 0; i < message.customFields.length; i++)
            SaleForm_CustomField.internalBinaryWrite(message.customFields[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.company.SaleForm
 */
export const SaleForm = new SaleForm$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SaleForm_CustomField$Type extends MessageType<SaleForm_CustomField> {
    constructor() {
        super("rd.company.SaleForm.CustomField", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "input_type", kind: "enum", T: () => ["rd.company.SaleForm.InputType", SaleForm_InputType] },
            { no: 3, name: "string_value", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SaleForm_CustomField>): SaleForm_CustomField {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.inputType = 0;
        message.stringValue = "";
        if (value !== undefined)
            reflectionMergePartial<SaleForm_CustomField>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SaleForm_CustomField): SaleForm_CustomField {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* rd.company.SaleForm.InputType input_type */ 2:
                    message.inputType = reader.int32();
                    break;
                case /* string string_value */ 3:
                    message.stringValue = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SaleForm_CustomField, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* rd.company.SaleForm.InputType input_type = 2; */
        if (message.inputType !== 0)
            writer.tag(2, WireType.Varint).int32(message.inputType);
        /* string string_value = 3; */
        if (message.stringValue !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.stringValue);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.company.SaleForm.CustomField
 */
export const SaleForm_CustomField = new SaleForm_CustomField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UnitOfMeasure$Type extends MessageType<UnitOfMeasure> {
    constructor() {
        super("rd.company.UnitOfMeasure", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "company_id", kind: "message", T: () => UUID },
            { no: 3, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "origin", kind: "enum", T: () => ["rd.company.UnitOfMeasureOrigin", UnitOfMeasureOrigin] },
            { no: 10, name: "integration_vendor", kind: "enum", T: () => ["rd.proto.integration_vendor.IntegrationVendor", IntegrationVendor, "INTEGRATION_VENDOR_"] }
        ]);
    }
    create(value?: PartialMessage<UnitOfMeasure>): UnitOfMeasure {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.code = "";
        message.name = "";
        message.notes = "";
        message.isActive = false;
        message.origin = 0;
        message.integrationVendor = 0;
        if (value !== undefined)
            reflectionMergePartial<UnitOfMeasure>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UnitOfMeasure): UnitOfMeasure {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 2:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* google.protobuf.Timestamp created_at */ 3:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 4:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* string code */ 5:
                    message.code = reader.string();
                    break;
                case /* string name */ 6:
                    message.name = reader.string();
                    break;
                case /* string notes */ 7:
                    message.notes = reader.string();
                    break;
                case /* bool is_active */ 8:
                    message.isActive = reader.bool();
                    break;
                case /* rd.company.UnitOfMeasureOrigin origin */ 9:
                    message.origin = reader.int32();
                    break;
                case /* rd.proto.integration_vendor.IntegrationVendor integration_vendor */ 10:
                    message.integrationVendor = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UnitOfMeasure, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 2; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 3; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 4; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string code = 5; */
        if (message.code !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.code);
        /* string name = 6; */
        if (message.name !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.name);
        /* string notes = 7; */
        if (message.notes !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.notes);
        /* bool is_active = 8; */
        if (message.isActive !== false)
            writer.tag(8, WireType.Varint).bool(message.isActive);
        /* rd.company.UnitOfMeasureOrigin origin = 9; */
        if (message.origin !== 0)
            writer.tag(9, WireType.Varint).int32(message.origin);
        /* rd.proto.integration_vendor.IntegrationVendor integration_vendor = 10; */
        if (message.integrationVendor !== 0)
            writer.tag(10, WireType.Varint).int32(message.integrationVendor);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.company.UnitOfMeasure
 */
export const UnitOfMeasure = new UnitOfMeasure$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TwilioCredentials$Type extends MessageType<TwilioCredentials> {
    constructor() {
        super("rd.company.TwilioCredentials", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "company_id", kind: "message", T: () => UUID },
            { no: 5, name: "account_sid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "api_key_sid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "encrypted_api_key", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 8, name: "encrypted_auth_token", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<TwilioCredentials>): TwilioCredentials {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountSid = "";
        message.apiKeySid = "";
        message.encryptedApiKey = new Uint8Array(0);
        message.encryptedAuthToken = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<TwilioCredentials>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TwilioCredentials): TwilioCredentials {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 4:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* string account_sid */ 5:
                    message.accountSid = reader.string();
                    break;
                case /* string api_key_sid */ 6:
                    message.apiKeySid = reader.string();
                    break;
                case /* bytes encrypted_api_key */ 7:
                    message.encryptedApiKey = reader.bytes();
                    break;
                case /* bytes encrypted_auth_token */ 8:
                    message.encryptedAuthToken = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TwilioCredentials, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 4; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string account_sid = 5; */
        if (message.accountSid !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.accountSid);
        /* string api_key_sid = 6; */
        if (message.apiKeySid !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.apiKeySid);
        /* bytes encrypted_api_key = 7; */
        if (message.encryptedApiKey.length)
            writer.tag(7, WireType.LengthDelimited).bytes(message.encryptedApiKey);
        /* bytes encrypted_auth_token = 8; */
        if (message.encryptedAuthToken.length)
            writer.tag(8, WireType.LengthDelimited).bytes(message.encryptedAuthToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.company.TwilioCredentials
 */
export const TwilioCredentials = new TwilioCredentials$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PricingRegion$Type extends MessageType<PricingRegion> {
    constructor() {
        super("rd.company.PricingRegion", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "company_id", kind: "message", T: () => UUID },
            { no: 3, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "is_default", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "position", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<PricingRegion>): PricingRegion {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.isActive = false;
        message.isDefault = false;
        message.position = 0;
        if (value !== undefined)
            reflectionMergePartial<PricingRegion>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PricingRegion): PricingRegion {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 2:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* google.protobuf.Timestamp created_at */ 3:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 4:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* string name */ 5:
                    message.name = reader.string();
                    break;
                case /* bool is_active */ 6:
                    message.isActive = reader.bool();
                    break;
                case /* bool is_default */ 7:
                    message.isDefault = reader.bool();
                    break;
                case /* int32 position */ 8:
                    message.position = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PricingRegion, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 2; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 3; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 4; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string name = 5; */
        if (message.name !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.name);
        /* bool is_active = 6; */
        if (message.isActive !== false)
            writer.tag(6, WireType.Varint).bool(message.isActive);
        /* bool is_default = 7; */
        if (message.isDefault !== false)
            writer.tag(7, WireType.Varint).bool(message.isDefault);
        /* int32 position = 8; */
        if (message.position !== 0)
            writer.tag(8, WireType.Varint).int32(message.position);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.company.PricingRegion
 */
export const PricingRegion = new PricingRegion$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CustomEmailConfig$Type extends MessageType<CustomEmailConfig> {
    constructor() {
        super("rd.company.CustomEmailConfig", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "company_id", kind: "message", T: () => UUID },
            { no: 3, name: "domain", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "status", kind: "enum", T: () => ["rd.company.CustomEmailConfig.Status", CustomEmailConfig_Status, "STATUS_"] },
            { no: 6, name: "sendgrid_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "dns_records", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CustomEmailConfig_DNSRecord },
            { no: 8, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 9, name: "updated_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<CustomEmailConfig>): CustomEmailConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.domain = "";
        message.enabled = false;
        message.status = 0;
        message.sendgridId = 0;
        message.dnsRecords = [];
        if (value !== undefined)
            reflectionMergePartial<CustomEmailConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CustomEmailConfig): CustomEmailConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 2:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* string domain */ 3:
                    message.domain = reader.string();
                    break;
                case /* bool enabled */ 4:
                    message.enabled = reader.bool();
                    break;
                case /* rd.company.CustomEmailConfig.Status status */ 5:
                    message.status = reader.int32();
                    break;
                case /* int32 sendgrid_id */ 6:
                    message.sendgridId = reader.int32();
                    break;
                case /* repeated rd.company.CustomEmailConfig.DNSRecord dns_records */ 7:
                    message.dnsRecords.push(CustomEmailConfig_DNSRecord.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* google.protobuf.Timestamp created_at */ 8:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 9:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CustomEmailConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 2; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string domain = 3; */
        if (message.domain !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.domain);
        /* bool enabled = 4; */
        if (message.enabled !== false)
            writer.tag(4, WireType.Varint).bool(message.enabled);
        /* rd.company.CustomEmailConfig.Status status = 5; */
        if (message.status !== 0)
            writer.tag(5, WireType.Varint).int32(message.status);
        /* int32 sendgrid_id = 6; */
        if (message.sendgridId !== 0)
            writer.tag(6, WireType.Varint).int32(message.sendgridId);
        /* repeated rd.company.CustomEmailConfig.DNSRecord dns_records = 7; */
        for (let i = 0; i < message.dnsRecords.length; i++)
            CustomEmailConfig_DNSRecord.internalBinaryWrite(message.dnsRecords[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 8; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 9; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.company.CustomEmailConfig
 */
export const CustomEmailConfig = new CustomEmailConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CustomEmailConfig_DNSRecord$Type extends MessageType<CustomEmailConfig_DNSRecord> {
    constructor() {
        super("rd.company.CustomEmailConfig.DNSRecord", [
            { no: 1, name: "name", kind: "enum", T: () => ["rd.company.CustomEmailConfig.DNSRecord.Record", CustomEmailConfig_DNSRecord_Record, "RECORD_"] },
            { no: 2, name: "valid", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "host", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "data", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CustomEmailConfig_DNSRecord>): CustomEmailConfig_DNSRecord {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = 0;
        message.valid = false;
        message.type = "";
        message.host = "";
        message.data = "";
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial<CustomEmailConfig_DNSRecord>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CustomEmailConfig_DNSRecord): CustomEmailConfig_DNSRecord {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.company.CustomEmailConfig.DNSRecord.Record name */ 1:
                    message.name = reader.int32();
                    break;
                case /* bool valid */ 2:
                    message.valid = reader.bool();
                    break;
                case /* string type */ 3:
                    message.type = reader.string();
                    break;
                case /* string host */ 4:
                    message.host = reader.string();
                    break;
                case /* string data */ 5:
                    message.data = reader.string();
                    break;
                case /* string reason */ 6:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CustomEmailConfig_DNSRecord, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.company.CustomEmailConfig.DNSRecord.Record name = 1; */
        if (message.name !== 0)
            writer.tag(1, WireType.Varint).int32(message.name);
        /* bool valid = 2; */
        if (message.valid !== false)
            writer.tag(2, WireType.Varint).bool(message.valid);
        /* string type = 3; */
        if (message.type !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.type);
        /* string host = 4; */
        if (message.host !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.host);
        /* string data = 5; */
        if (message.data !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.data);
        /* string reason = 6; */
        if (message.reason !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.company.CustomEmailConfig.DNSRecord
 */
export const CustomEmailConfig_DNSRecord = new CustomEmailConfig_DNSRecord$Type();
